import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n6 = 0, F = function F() {}; return { s: F, n: function n() { return _n6 >= r.length ? { done: !0 } : { done: !1, value: r[_n6++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var e = {
  graph: {
    meta: {
      rankDir: "TB",
      nodeSep: 50,
      rankSep: 50,
      edgeSep: 5,
      align: void 0
    }
  },
  subScene: {
    meta: {
      paddingTop: 20,
      paddingBottom: 20,
      paddingLeft: 20,
      paddingRight: 20,
      labelHeight: 20
    }
  },
  nodeSize: {
    meta: {
      width: 100,
      maxLabelWidth: 0,
      height: 20
    },
    node: {
      width: 80,
      height: 20,
      labelOffset: 10,
      maxLabelWidth: 40
    },
    bridge: {
      width: 5,
      height: 5,
      radius: 2,
      labelOffset: 0
    }
  }
};
function n() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e;
  var r, o, i, a;
  var u = JSON.parse(JSON.stringify(t)),
    c = (null === (r = null == n ? void 0 : n.graph) || void 0 === r ? void 0 : r.meta) || {},
    s = (null === (o = null == n ? void 0 : n.subScene) || void 0 === o ? void 0 : o.meta) || {},
    d = (null === (i = null == n ? void 0 : n.nodeSize) || void 0 === i ? void 0 : i.meta) || {},
    f = (null === (a = null == n ? void 0 : n.nodeSize) || void 0 === a ? void 0 : a.node) || {},
    h = u.nodeSize.bridge;
  return {
    graph: {
      meta: Object.assign(u.graph.meta, c)
    },
    subScene: {
      meta: Object.assign(u.subScene.meta, s)
    },
    nodeSize: {
      meta: Object.assign(u.nodeSize.meta, d),
      node: Object.assign(u.nodeSize.node, f),
      bridge: h
    }
  };
}
function t(e) {
  return "\u25EC".concat(e, "\u25EC");
}
var r = t("ROOT"),
  o = t("BRIDGE_GRAPH");
var i, a, u, c;
!function (e) {
  e[e.META = 0] = "META", e[e.NODE = 1] = "NODE", e[e.BRIDGE = 2] = "BRIDGE";
}(i || (i = {})), function (e) {
  e[e.INCLUDE = 0] = "INCLUDE", e[e.EXCLUDE = 1] = "EXCLUDE", e[e.UNSPECIFIED = 2] = "UNSPECIFIED";
}(a || (a = {})), function (e) {
  e[e.META = 0] = "META", e[e.CORE = 1] = "CORE", e[e.BRIDGE = 2] = "BRIDGE";
}(u || (u = {})), function (e) {
  e[e.META = 0] = "META", e[e.OP = 1] = "OP", e[e.SERIES = 2] = "SERIES";
}(c || (c = {}));
var s = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function d(e, n) {
  return e(n = {
    exports: {}
  }, n.exports), n.exports;
}
var f = function f() {
  this.__data__ = [], this.size = 0;
};
var h = function h(e, n) {
  return e === n || e != e && n != n;
};
var l = function l(e, n) {
    for (var t = e.length; t--;) if (h(e[t][0], n)) return t;
    return -1;
  },
  v = Array.prototype.splice;
var p = function p(e) {
  var n = this.__data__,
    t = l(n, e);
  return !(t < 0) && (t == n.length - 1 ? n.pop() : v.call(n, t, 1), --this.size, !0);
};
var g = function g(e) {
  var n = this.__data__,
    t = l(n, e);
  return t < 0 ? void 0 : n[t][1];
};
var y = function y(e) {
  return l(this.__data__, e) > -1;
};
var b = function b(e, n) {
  var t = this.__data__,
    r = l(t, e);
  return r < 0 ? (++this.size, t.push([e, n])) : t[r][1] = n, this;
};
function m(e) {
  var n = -1,
    t = null == e ? 0 : e.length;
  for (this.clear(); ++n < t;) {
    var r = e[n];
    this.set(r[0], r[1]);
  }
}
m.prototype.clear = f, m.prototype.delete = p, m.prototype.get = g, m.prototype.has = y, m.prototype.set = b;
var w = m;
var E = function E() {
  this.__data__ = new w(), this.size = 0;
};
var _ = function _(e) {
  var n = this.__data__,
    t = n.delete(e);
  return this.size = n.size, t;
};
var j = function j(e) {
  return this.__data__.get(e);
};
var x = function x(e) {
    return this.__data__.has(e);
  },
  N = "object" == typeof s && s && s.Object === Object && s,
  O = "object" == typeof self && self && self.Object === Object && self,
  k = N || O || Function("return this")(),
  I = k.Symbol,
  S = Object.prototype,
  M = S.hasOwnProperty,
  C = S.toString,
  G = I ? I.toStringTag : void 0;
var B = function B(e) {
    var n = M.call(e, G),
      t = e[G];
    try {
      e[G] = void 0;
      var r = !0;
    } catch (e) {}
    var o = C.call(e);
    return r && (n ? e[G] = t : delete e[G]), o;
  },
  A = Object.prototype.toString;
var L = function L(e) {
    return A.call(e);
  },
  R = I ? I.toStringTag : void 0;
var T = function T(e) {
  return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : R && R in Object(e) ? B(e) : L(e);
};
var D = function D(e) {
  var n = typeof e;
  return null != e && ("object" == n || "function" == n);
};
var P,
  z = function z(e) {
    if (!D(e)) return !1;
    var n = T(e);
    return "[object Function]" == n || "[object GeneratorFunction]" == n || "[object AsyncFunction]" == n || "[object Proxy]" == n;
  },
  F = k["__core-js_shared__"],
  U = (P = /[^.]+$/.exec(F && F.keys && F.keys.IE_PROTO || "")) ? "Symbol(src)_1." + P : "";
var V = function V(e) {
    return !!U && U in e;
  },
  $ = Function.prototype.toString;
var H = function H(e) {
    if (null != e) {
      try {
        return $.call(e);
      } catch (e) {}
      try {
        return e + "";
      } catch (e) {}
    }
    return "";
  },
  W = /^\[object .+?Constructor\]$/,
  q = Function.prototype,
  Y = Object.prototype,
  J = q.toString,
  X = Y.hasOwnProperty,
  K = RegExp("^" + J.call(X).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
var Q = function Q(e) {
  return !(!D(e) || V(e)) && (z(e) ? K : W).test(H(e));
};
var Z = function Z(e, n) {
  return null == e ? void 0 : e[n];
};
var ee = function ee(e, n) {
    var t = Z(e, n);
    return Q(t) ? t : void 0;
  },
  ne = ee(k, "Map"),
  te = ee(Object, "create");
var re = function re() {
  this.__data__ = te ? te(null) : {}, this.size = 0;
};
var oe = function oe(e) {
    var n = this.has(e) && delete this.__data__[e];
    return this.size -= n ? 1 : 0, n;
  },
  ie = Object.prototype.hasOwnProperty;
var ae = function ae(e) {
    var n = this.__data__;
    if (te) {
      var t = n[e];
      return "__lodash_hash_undefined__" === t ? void 0 : t;
    }
    return ie.call(n, e) ? n[e] : void 0;
  },
  ue = Object.prototype.hasOwnProperty;
var ce = function ce(e) {
  var n = this.__data__;
  return te ? void 0 !== n[e] : ue.call(n, e);
};
var se = function se(e, n) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = te && void 0 === n ? "__lodash_hash_undefined__" : n, this;
};
function de(e) {
  var n = -1,
    t = null == e ? 0 : e.length;
  for (this.clear(); ++n < t;) {
    var r = e[n];
    this.set(r[0], r[1]);
  }
}
de.prototype.clear = re, de.prototype.delete = oe, de.prototype.get = ae, de.prototype.has = ce, de.prototype.set = se;
var fe = de;
var he = function he() {
  this.size = 0, this.__data__ = {
    hash: new fe(),
    map: new (ne || w)(),
    string: new fe()
  };
};
var le = function le(e) {
  var n = typeof e;
  return "string" == n || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== e : null === e;
};
var ve = function ve(e, n) {
  var t = e.__data__;
  return le(n) ? t["string" == typeof n ? "string" : "hash"] : t.map;
};
var pe = function pe(e) {
  var n = ve(this, e).delete(e);
  return this.size -= n ? 1 : 0, n;
};
var ge = function ge(e) {
  return ve(this, e).get(e);
};
var ye = function ye(e) {
  return ve(this, e).has(e);
};
var be = function be(e, n) {
  var t = ve(this, e),
    r = t.size;
  return t.set(e, n), this.size += t.size == r ? 0 : 1, this;
};
function me(e) {
  var n = -1,
    t = null == e ? 0 : e.length;
  for (this.clear(); ++n < t;) {
    var r = e[n];
    this.set(r[0], r[1]);
  }
}
me.prototype.clear = he, me.prototype.delete = pe, me.prototype.get = ge, me.prototype.has = ye, me.prototype.set = be;
var we = me;
var Ee = function Ee(e, n) {
  var t = this.__data__;
  if (t instanceof w) {
    var r = t.__data__;
    if (!ne || r.length < 199) return r.push([e, n]), this.size = ++t.size, this;
    t = this.__data__ = new we(r);
  }
  return t.set(e, n), this.size = t.size, this;
};
function _e(e) {
  var n = this.__data__ = new w(e);
  this.size = n.size;
}
_e.prototype.clear = E, _e.prototype.delete = _, _e.prototype.get = j, _e.prototype.has = x, _e.prototype.set = Ee;
var je = _e;
var xe = function xe(e, n) {
    for (var t = -1, r = null == e ? 0 : e.length; ++t < r && !1 !== n(e[t], t, e););
    return e;
  },
  Ne = function () {
    try {
      var e = ee(Object, "defineProperty");
      return e({}, "", {}), e;
    } catch (e) {}
  }();
var Oe = function Oe(e, n, t) {
    "__proto__" == n && Ne ? Ne(e, n, {
      configurable: !0,
      enumerable: !0,
      value: t,
      writable: !0
    }) : e[n] = t;
  },
  ke = Object.prototype.hasOwnProperty;
var Ie = function Ie(e, n, t) {
  var r = e[n];
  ke.call(e, n) && h(r, t) && (void 0 !== t || n in e) || Oe(e, n, t);
};
var Se = function Se(e, n, t, r) {
  var o = !t;
  t || (t = {});
  for (var i = -1, a = n.length; ++i < a;) {
    var u = n[i],
      c = r ? r(t[u], e[u], u, t, e) : void 0;
    void 0 === c && (c = e[u]), o ? Oe(t, u, c) : Ie(t, u, c);
  }
  return t;
};
var Me = function Me(e, n) {
  for (var t = -1, r = Array(e); ++t < e;) r[t] = n(t);
  return r;
};
var Ce = function Ce(e) {
  return null != e && "object" == typeof e;
};
var Ge = function Ge(e) {
    return Ce(e) && "[object Arguments]" == T(e);
  },
  Be = Object.prototype,
  Ae = Be.hasOwnProperty,
  Le = Be.propertyIsEnumerable,
  Re = Ge(function () {
    return arguments;
  }()) ? Ge : function (e) {
    return Ce(e) && Ae.call(e, "callee") && !Le.call(e, "callee");
  },
  Te = Array.isArray;
var De = function De() {
    return !1;
  },
  Pe = d(function (e, n) {
    var t = n && !n.nodeType && n,
      r = t && e && !e.nodeType && e,
      o = r && r.exports === t ? k.Buffer : void 0,
      i = (o ? o.isBuffer : void 0) || De;
    e.exports = i;
  }),
  ze = /^(?:0|[1-9]\d*)$/;
var Fe = function Fe(e, n) {
  var t = typeof e;
  return !!(n = null == n ? 9007199254740991 : n) && ("number" == t || "symbol" != t && ze.test(e)) && e > -1 && e % 1 == 0 && e < n;
};
var Ue = function Ue(e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
  },
  Ve = {};
Ve["[object Float32Array]"] = Ve["[object Float64Array]"] = Ve["[object Int8Array]"] = Ve["[object Int16Array]"] = Ve["[object Int32Array]"] = Ve["[object Uint8Array]"] = Ve["[object Uint8ClampedArray]"] = Ve["[object Uint16Array]"] = Ve["[object Uint32Array]"] = !0, Ve["[object Arguments]"] = Ve["[object Array]"] = Ve["[object ArrayBuffer]"] = Ve["[object Boolean]"] = Ve["[object DataView]"] = Ve["[object Date]"] = Ve["[object Error]"] = Ve["[object Function]"] = Ve["[object Map]"] = Ve["[object Number]"] = Ve["[object Object]"] = Ve["[object RegExp]"] = Ve["[object Set]"] = Ve["[object String]"] = Ve["[object WeakMap]"] = !1;
var $e = function $e(e) {
  return Ce(e) && Ue(e.length) && !!Ve[T(e)];
};
var He = function He(e) {
    return function (n) {
      return e(n);
    };
  },
  We = d(function (e, n) {
    var t = n && !n.nodeType && n,
      r = t && e && !e.nodeType && e,
      o = r && r.exports === t && N.process,
      i = function () {
        try {
          var e = r && r.require && r.require("util").types;
          return e || o && o.binding && o.binding("util");
        } catch (e) {}
      }();
    e.exports = i;
  }),
  qe = We && We.isTypedArray,
  Ye = qe ? He(qe) : $e,
  Je = Object.prototype.hasOwnProperty;
var Xe = function Xe(e, n) {
    var t = Te(e),
      r = !t && Re(e),
      o = !t && !r && Pe(e),
      i = !t && !r && !o && Ye(e),
      a = t || r || o || i,
      u = a ? Me(e.length, String) : [],
      c = u.length;
    for (var s in e) !n && !Je.call(e, s) || a && ("length" == s || o && ("offset" == s || "parent" == s) || i && ("buffer" == s || "byteLength" == s || "byteOffset" == s) || Fe(s, c)) || u.push(s);
    return u;
  },
  Ke = Object.prototype;
var Qe = function Qe(e) {
  var n = e && e.constructor;
  return e === ("function" == typeof n && n.prototype || Ke);
};
var Ze = function Ze(e, n) {
    return function (t) {
      return e(n(t));
    };
  },
  en = Ze(Object.keys, Object),
  nn = Object.prototype.hasOwnProperty;
var tn = function tn(e) {
  if (!Qe(e)) return en(e);
  var n = [];
  for (var t in Object(e)) nn.call(e, t) && "constructor" != t && n.push(t);
  return n;
};
var rn = function rn(e) {
  return null != e && Ue(e.length) && !z(e);
};
var on = function on(e) {
  return rn(e) ? Xe(e) : tn(e);
};
var an = function an(e, n) {
  return e && Se(n, on(n), e);
};
var un = function un(e) {
    var n = [];
    if (null != e) for (var t in Object(e)) n.push(t);
    return n;
  },
  cn = Object.prototype.hasOwnProperty;
var sn = function sn(e) {
  if (!D(e)) return un(e);
  var n = Qe(e),
    t = [];
  for (var r in e) ("constructor" != r || !n && cn.call(e, r)) && t.push(r);
  return t;
};
var dn = function dn(e) {
  return rn(e) ? Xe(e, !0) : sn(e);
};
var fn = function fn(e, n) {
    return e && Se(n, dn(n), e);
  },
  hn = d(function (e, n) {
    var t = n && !n.nodeType && n,
      r = t && e && !e.nodeType && e,
      o = r && r.exports === t ? k.Buffer : void 0,
      i = o ? o.allocUnsafe : void 0;
    e.exports = function (e, n) {
      if (n) return e.slice();
      var t = e.length,
        r = i ? i(t) : new e.constructor(t);
      return e.copy(r), r;
    };
  });
var ln = function ln(e, n) {
  var t = -1,
    r = e.length;
  for (n || (n = Array(r)); ++t < r;) n[t] = e[t];
  return n;
};
var vn = function vn(e, n) {
  for (var t = -1, r = null == e ? 0 : e.length, o = 0, i = []; ++t < r;) {
    var a = e[t];
    n(a, t, e) && (i[o++] = a);
  }
  return i;
};
var pn = function pn() {
    return [];
  },
  gn = Object.prototype.propertyIsEnumerable,
  yn = Object.getOwnPropertySymbols,
  bn = yn ? function (e) {
    return null == e ? [] : (e = Object(e), vn(yn(e), function (n) {
      return gn.call(e, n);
    }));
  } : pn;
var mn = function mn(e, n) {
  return Se(e, bn(e), n);
};
var wn = function wn(e, n) {
    for (var t = -1, r = n.length, o = e.length; ++t < r;) e[o + t] = n[t];
    return e;
  },
  En = Ze(Object.getPrototypeOf, Object),
  _n = Object.getOwnPropertySymbols ? function (e) {
    for (var n = []; e;) wn(n, bn(e)), e = En(e);
    return n;
  } : pn;
var jn = function jn(e, n) {
  return Se(e, _n(e), n);
};
var xn = function xn(e, n, t) {
  var r = n(e);
  return Te(e) ? r : wn(r, t(e));
};
var Nn = function Nn(e) {
  return xn(e, on, bn);
};
var On = function On(e) {
    return xn(e, dn, _n);
  },
  kn = ee(k, "DataView"),
  In = ee(k, "Promise"),
  Sn = ee(k, "Set"),
  Mn = ee(k, "WeakMap"),
  Cn = H(kn),
  Gn = H(ne),
  Bn = H(In),
  An = H(Sn),
  Ln = H(Mn),
  Rn = T;
(kn && "[object DataView]" != Rn(new kn(new ArrayBuffer(1))) || ne && "[object Map]" != Rn(new ne()) || In && "[object Promise]" != Rn(In.resolve()) || Sn && "[object Set]" != Rn(new Sn()) || Mn && "[object WeakMap]" != Rn(new Mn())) && (Rn = function Rn(e) {
  var n = T(e),
    t = "[object Object]" == n ? e.constructor : void 0,
    r = t ? H(t) : "";
  if (r) switch (r) {
    case Cn:
      return "[object DataView]";
    case Gn:
      return "[object Map]";
    case Bn:
      return "[object Promise]";
    case An:
      return "[object Set]";
    case Ln:
      return "[object WeakMap]";
  }
  return n;
});
var Tn = Rn,
  Dn = Object.prototype.hasOwnProperty;
var Pn = function Pn(e) {
    var n = e.length,
      t = new e.constructor(n);
    return n && "string" == typeof e[0] && Dn.call(e, "index") && (t.index = e.index, t.input = e.input), t;
  },
  zn = k.Uint8Array;
var Fn = function Fn(e) {
  var n = new e.constructor(e.byteLength);
  return new zn(n).set(new zn(e)), n;
};
var Un = function Un(e, n) {
    var t = n ? Fn(e.buffer) : e.buffer;
    return new e.constructor(t, e.byteOffset, e.byteLength);
  },
  Vn = /\w*$/;
var $n = function $n(e) {
    var n = new e.constructor(e.source, Vn.exec(e));
    return n.lastIndex = e.lastIndex, n;
  },
  Hn = I ? I.prototype : void 0,
  Wn = Hn ? Hn.valueOf : void 0;
var qn = function qn(e) {
  return Wn ? Object(Wn.call(e)) : {};
};
var Yn = function Yn(e, n) {
  var t = n ? Fn(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.length);
};
var Jn = function Jn(e, n, t) {
    var r = e.constructor;
    switch (n) {
      case "[object ArrayBuffer]":
        return Fn(e);
      case "[object Boolean]":
      case "[object Date]":
        return new r(+e);
      case "[object DataView]":
        return Un(e, t);
      case "[object Float32Array]":
      case "[object Float64Array]":
      case "[object Int8Array]":
      case "[object Int16Array]":
      case "[object Int32Array]":
      case "[object Uint8Array]":
      case "[object Uint8ClampedArray]":
      case "[object Uint16Array]":
      case "[object Uint32Array]":
        return Yn(e, t);
      case "[object Map]":
        return new r();
      case "[object Number]":
      case "[object String]":
        return new r(e);
      case "[object RegExp]":
        return $n(e);
      case "[object Set]":
        return new r();
      case "[object Symbol]":
        return qn(e);
    }
  },
  Xn = Object.create,
  Kn = function () {
    function e() {}
    return function (n) {
      if (!D(n)) return {};
      if (Xn) return Xn(n);
      e.prototype = n;
      var t = new e();
      return e.prototype = void 0, t;
    };
  }();
var Qn = function Qn(e) {
  return "function" != typeof e.constructor || Qe(e) ? {} : Kn(En(e));
};
var Zn = function Zn(e) {
    return Ce(e) && "[object Map]" == Tn(e);
  },
  et = We && We.isMap,
  nt = et ? He(et) : Zn;
var tt = function tt(e) {
    return Ce(e) && "[object Set]" == Tn(e);
  },
  rt = We && We.isSet,
  ot = rt ? He(rt) : tt,
  it = {};
it["[object Arguments]"] = it["[object Array]"] = it["[object ArrayBuffer]"] = it["[object DataView]"] = it["[object Boolean]"] = it["[object Date]"] = it["[object Float32Array]"] = it["[object Float64Array]"] = it["[object Int8Array]"] = it["[object Int16Array]"] = it["[object Int32Array]"] = it["[object Map]"] = it["[object Number]"] = it["[object Object]"] = it["[object RegExp]"] = it["[object Set]"] = it["[object String]"] = it["[object Symbol]"] = it["[object Uint8Array]"] = it["[object Uint8ClampedArray]"] = it["[object Uint16Array]"] = it["[object Uint32Array]"] = !0, it["[object Error]"] = it["[object Function]"] = it["[object WeakMap]"] = !1;
var at = function e(n, t, r, o, i, a) {
  var u,
    c = 1 & t,
    s = 2 & t,
    d = 4 & t;
  if (r && (u = i ? r(n, o, i, a) : r(n)), void 0 !== u) return u;
  if (!D(n)) return n;
  var f = Te(n);
  if (f) {
    if (u = Pn(n), !c) return ln(n, u);
  } else {
    var h = Tn(n),
      l = "[object Function]" == h || "[object GeneratorFunction]" == h;
    if (Pe(n)) return hn(n, c);
    if ("[object Object]" == h || "[object Arguments]" == h || l && !i) {
      if (u = s || l ? {} : Qn(n), !c) return s ? jn(n, fn(u, n)) : mn(n, an(u, n));
    } else {
      if (!it[h]) return i ? n : {};
      u = Jn(n, h, c);
    }
  }
  a || (a = new je());
  var v = a.get(n);
  if (v) return v;
  a.set(n, u), ot(n) ? n.forEach(function (o) {
    u.add(e(o, t, r, o, n, a));
  }) : nt(n) && n.forEach(function (o, i) {
    u.set(i, e(o, t, r, i, n, a));
  });
  var p = f ? void 0 : (d ? s ? On : Nn : s ? dn : on)(n);
  return xe(p || n, function (o, i) {
    p && (o = n[i = o]), Ie(u, i, e(o, t, r, i, n, a));
  }), u;
};
var ut = function ut(e) {
  return at(e, 4);
};
var ct = function ct(e) {
  return function () {
    return e;
  };
};
var st = function (e) {
  return function (n, t, r) {
    for (var o = -1, i = Object(n), a = r(n), u = a.length; u--;) {
      var c = a[e ? u : ++o];
      if (!1 === t(i[c], c, i)) break;
    }
    return n;
  };
}();
var dt = function dt(e, n) {
  return e && st(e, n, on);
};
var ft = function (e, n) {
  return function (t, r) {
    if (null == t) return t;
    if (!rn(t)) return e(t, r);
    for (var o = t.length, i = n ? o : -1, a = Object(t); (n ? i-- : ++i < o) && !1 !== r(a[i], i, a););
    return t;
  };
}(dt);
var ht = function ht(e) {
  return e;
};
var lt = function lt(e) {
  return "function" == typeof e ? e : ht;
};
var vt = function vt(e, n) {
    return (Te(e) ? xe : ft)(e, lt(n));
  },
  pt = vt;
var gt = function gt(e, n) {
  var t = [];
  return ft(e, function (e, r, o) {
    n(e, r, o) && t.push(e);
  }), t;
};
var yt = function yt(e) {
  return this.__data__.set(e, "__lodash_hash_undefined__"), this;
};
var bt = function bt(e) {
  return this.__data__.has(e);
};
function mt(e) {
  var n = -1,
    t = null == e ? 0 : e.length;
  for (this.__data__ = new we(); ++n < t;) this.add(e[n]);
}
mt.prototype.add = mt.prototype.push = yt, mt.prototype.has = bt;
var wt = mt;
var Et = function Et(e, n) {
  for (var t = -1, r = null == e ? 0 : e.length; ++t < r;) if (n(e[t], t, e)) return !0;
  return !1;
};
var _t = function _t(e, n) {
  return e.has(n);
};
var jt = function jt(e, n, t, r, o, i) {
  var a = 1 & t,
    u = e.length,
    c = n.length;
  if (u != c && !(a && c > u)) return !1;
  var s = i.get(e),
    d = i.get(n);
  if (s && d) return s == n && d == e;
  var f = -1,
    h = !0,
    l = 2 & t ? new wt() : void 0;
  for (i.set(e, n), i.set(n, e); ++f < u;) {
    var v = e[f],
      p = n[f];
    if (r) var g = a ? r(p, v, f, n, e, i) : r(v, p, f, e, n, i);
    if (void 0 !== g) {
      if (g) continue;
      h = !1;
      break;
    }
    if (l) {
      if (!Et(n, function (e, n) {
        if (!_t(l, n) && (v === e || o(v, e, t, r, i))) return l.push(n);
      })) {
        h = !1;
        break;
      }
    } else if (v !== p && !o(v, p, t, r, i)) {
      h = !1;
      break;
    }
  }
  return i.delete(e), i.delete(n), h;
};
var xt = function xt(e) {
  var n = -1,
    t = Array(e.size);
  return e.forEach(function (e, r) {
    t[++n] = [r, e];
  }), t;
};
var Nt = function Nt(e) {
    var n = -1,
      t = Array(e.size);
    return e.forEach(function (e) {
      t[++n] = e;
    }), t;
  },
  Ot = I ? I.prototype : void 0,
  kt = Ot ? Ot.valueOf : void 0;
var It = function It(e, n, t, r, o, i, a) {
    switch (t) {
      case "[object DataView]":
        if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset) return !1;
        e = e.buffer, n = n.buffer;
      case "[object ArrayBuffer]":
        return !(e.byteLength != n.byteLength || !i(new zn(e), new zn(n)));
      case "[object Boolean]":
      case "[object Date]":
      case "[object Number]":
        return h(+e, +n);
      case "[object Error]":
        return e.name == n.name && e.message == n.message;
      case "[object RegExp]":
      case "[object String]":
        return e == n + "";
      case "[object Map]":
        var u = xt;
      case "[object Set]":
        var c = 1 & r;
        if (u || (u = Nt), e.size != n.size && !c) return !1;
        var s = a.get(e);
        if (s) return s == n;
        r |= 2, a.set(e, n);
        var d = jt(u(e), u(n), r, o, i, a);
        return a.delete(e), d;
      case "[object Symbol]":
        if (kt) return kt.call(e) == kt.call(n);
    }
    return !1;
  },
  St = Object.prototype.hasOwnProperty;
var Mt = function Mt(e, n, t, r, o, i) {
    var a = 1 & t,
      u = Nn(e),
      c = u.length;
    if (c != Nn(n).length && !a) return !1;
    for (var s = c; s--;) {
      var d = u[s];
      if (!(a ? d in n : St.call(n, d))) return !1;
    }
    var f = i.get(e),
      h = i.get(n);
    if (f && h) return f == n && h == e;
    var l = !0;
    i.set(e, n), i.set(n, e);
    for (var v = a; ++s < c;) {
      var p = e[d = u[s]],
        g = n[d];
      if (r) var y = a ? r(g, p, d, n, e, i) : r(p, g, d, e, n, i);
      if (!(void 0 === y ? p === g || o(p, g, t, r, i) : y)) {
        l = !1;
        break;
      }
      v || (v = "constructor" == d);
    }
    if (l && !v) {
      var b = e.constructor,
        m = n.constructor;
      b == m || !("constructor" in e) || !("constructor" in n) || "function" == typeof b && b instanceof b && "function" == typeof m && m instanceof m || (l = !1);
    }
    return i.delete(e), i.delete(n), l;
  },
  Ct = Object.prototype.hasOwnProperty;
var Gt = function Gt(e, n, t, r, o, i) {
  var a = Te(e),
    u = Te(n),
    c = a ? "[object Array]" : Tn(e),
    s = u ? "[object Array]" : Tn(n),
    d = "[object Object]" == (c = "[object Arguments]" == c ? "[object Object]" : c),
    f = "[object Object]" == (s = "[object Arguments]" == s ? "[object Object]" : s),
    h = c == s;
  if (h && Pe(e)) {
    if (!Pe(n)) return !1;
    a = !0, d = !1;
  }
  if (h && !d) return i || (i = new je()), a || Ye(e) ? jt(e, n, t, r, o, i) : It(e, n, c, t, r, o, i);
  if (!(1 & t)) {
    var l = d && Ct.call(e, "__wrapped__"),
      v = f && Ct.call(n, "__wrapped__");
    if (l || v) {
      var p = l ? e.value() : e,
        g = v ? n.value() : n;
      return i || (i = new je()), o(p, g, t, r, i);
    }
  }
  return !!h && (i || (i = new je()), Mt(e, n, t, r, o, i));
};
var Bt = function e(n, t, r, o, i) {
  return n === t || (null == n || null == t || !Ce(n) && !Ce(t) ? n != n && t != t : Gt(n, t, r, o, e, i));
};
var At = function At(e, n, t, r) {
  var o = t.length,
    i = o,
    a = !r;
  if (null == e) return !i;
  for (e = Object(e); o--;) {
    var u = t[o];
    if (a && u[2] ? u[1] !== e[u[0]] : !(u[0] in e)) return !1;
  }
  for (; ++o < i;) {
    var c = (u = t[o])[0],
      s = e[c],
      d = u[1];
    if (a && u[2]) {
      if (void 0 === s && !(c in e)) return !1;
    } else {
      var f = new je();
      if (r) var h = r(s, d, c, e, n, f);
      if (!(void 0 === h ? Bt(d, s, 3, r, f) : h)) return !1;
    }
  }
  return !0;
};
var Lt = function Lt(e) {
  return e == e && !D(e);
};
var Rt = function Rt(e) {
  for (var n = on(e), t = n.length; t--;) {
    var r = n[t],
      o = e[r];
    n[t] = [r, o, Lt(o)];
  }
  return n;
};
var Tt = function Tt(e, n) {
  return function (t) {
    return null != t && t[e] === n && (void 0 !== n || e in Object(t));
  };
};
var Dt = function Dt(e) {
  var n = Rt(e);
  return 1 == n.length && n[0][2] ? Tt(n[0][0], n[0][1]) : function (t) {
    return t === e || At(t, e, n);
  };
};
var Pt = function Pt(e) {
    return "symbol" == typeof e || Ce(e) && "[object Symbol]" == T(e);
  },
  zt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  Ft = /^\w*$/;
var Ut = function Ut(e, n) {
  if (Te(e)) return !1;
  var t = typeof e;
  return !("number" != t && "symbol" != t && "boolean" != t && null != e && !Pt(e)) || Ft.test(e) || !zt.test(e) || null != n && e in Object(n);
};
function Vt(e, n) {
  if ("function" != typeof e || null != n && "function" != typeof n) throw new TypeError("Expected a function");
  var _t2 = function t() {
    var r = arguments,
      o = n ? n.apply(this, r) : r[0],
      i = _t2.cache;
    if (i.has(o)) return i.get(o);
    var a = e.apply(this, r);
    return _t2.cache = i.set(o, a) || i, a;
  };
  return _t2.cache = new (Vt.Cache || we)(), _t2;
}
Vt.Cache = we;
var $t = Vt;
var Ht = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
  Wt = /\\(\\)?/g,
  qt = function (e) {
    var n = $t(e, function (e) {
        return 500 === t.size && t.clear(), e;
      }),
      t = n.cache;
    return n;
  }(function (e) {
    var n = [];
    return 46 === e.charCodeAt(0) && n.push(""), e.replace(Ht, function (e, t, r, o) {
      n.push(r ? o.replace(Wt, "$1") : t || e);
    }), n;
  });
var Yt = function Yt(e, n) {
    for (var t = -1, r = null == e ? 0 : e.length, o = Array(r); ++t < r;) o[t] = n(e[t], t, e);
    return o;
  },
  Jt = I ? I.prototype : void 0,
  Xt = Jt ? Jt.toString : void 0;
var Kt = function e(n) {
  if ("string" == typeof n) return n;
  if (Te(n)) return Yt(n, e) + "";
  if (Pt(n)) return Xt ? Xt.call(n) : "";
  var t = n + "";
  return "0" == t && 1 / n == -Infinity ? "-0" : t;
};
var Qt = function Qt(e) {
  return null == e ? "" : Kt(e);
};
var Zt = function Zt(e, n) {
  return Te(e) ? e : Ut(e, n) ? [e] : qt(Qt(e));
};
var er = function er(e) {
  if ("string" == typeof e || Pt(e)) return e;
  var n = e + "";
  return "0" == n && 1 / e == -Infinity ? "-0" : n;
};
var nr = function nr(e, n) {
  for (var t = 0, r = (n = Zt(n, e)).length; null != e && t < r;) e = e[er(n[t++])];
  return t && t == r ? e : void 0;
};
var tr = function tr(e, n, t) {
  var r = null == e ? void 0 : nr(e, n);
  return void 0 === r ? t : r;
};
var rr = function rr(e, n) {
  return null != e && n in Object(e);
};
var or = function or(e, n, t) {
  for (var r = -1, o = (n = Zt(n, e)).length, i = !1; ++r < o;) {
    var a = er(n[r]);
    if (!(i = null != e && t(e, a))) break;
    e = e[a];
  }
  return i || ++r != o ? i : !!(o = null == e ? 0 : e.length) && Ue(o) && Fe(a, o) && (Te(e) || Re(e));
};
var ir = function ir(e, n) {
  return null != e && or(e, n, rr);
};
var ar = function ar(e, n) {
  return Ut(e) && Lt(n) ? Tt(er(e), n) : function (t) {
    var r = tr(t, e);
    return void 0 === r && r === n ? ir(t, e) : Bt(n, r, 3);
  };
};
var ur = function ur(e) {
  return function (n) {
    return null == n ? void 0 : n[e];
  };
};
var cr = function cr(e) {
  return function (n) {
    return nr(n, e);
  };
};
var sr = function sr(e) {
  return Ut(e) ? ur(er(e)) : cr(e);
};
var dr = function dr(e) {
  return "function" == typeof e ? e : null == e ? ht : "object" == typeof e ? Te(e) ? ar(e[0], e[1]) : Dt(e) : sr(e);
};
var fr = function fr(e, n) {
    return (Te(e) ? vn : gt)(e, dr(n));
  },
  hr = Object.prototype.hasOwnProperty;
var lr = function lr(e, n) {
  return null != e && hr.call(e, n);
};
var vr = function vr(e, n) {
    return null != e && or(e, n, lr);
  },
  pr = Object.prototype.hasOwnProperty;
var gr = function gr(e) {
  if (null == e) return !0;
  if (rn(e) && (Te(e) || "string" == typeof e || "function" == typeof e.splice || Pe(e) || Ye(e) || Re(e))) return !e.length;
  var n = Tn(e);
  if ("[object Map]" == n || "[object Set]" == n) return !e.size;
  if (Qe(e)) return !tn(e).length;
  for (var t in e) if (pr.call(e, t)) return !1;
  return !0;
};
var yr = function yr(e) {
  return void 0 === e;
};
var br = function br(e, n) {
  var t = -1,
    r = rn(e) ? Array(e.length) : [];
  return ft(e, function (e, o, i) {
    r[++t] = n(e, o, i);
  }), r;
};
var mr = function mr(e, n) {
  return (Te(e) ? Yt : br)(e, dr(n));
};
var wr = function wr(e, n, t, r) {
  var o = -1,
    i = null == e ? 0 : e.length;
  for (r && i && (t = e[++o]); ++o < i;) t = n(t, e[o], o, e);
  return t;
};
var Er = function Er(e, n, t, r, o) {
  return o(e, function (e, o, i) {
    t = r ? (r = !1, e) : n(t, e, o, i);
  }), t;
};
var _r = function _r(e, n, t) {
  var r = Te(e) ? wr : Er,
    o = arguments.length < 3;
  return r(e, dr(n), t, o, ft);
};
var jr = function jr(e) {
    return "string" == typeof e || !Te(e) && Ce(e) && "[object String]" == T(e);
  },
  xr = ur("length"),
  Nr = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
var Or = function Or(e) {
    return Nr.test(e);
  },
  kr = "[\\ud800-\\udfff]",
  Ir = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
  Sr = "\\ud83c[\\udffb-\\udfff]",
  Mr = "[^\\ud800-\\udfff]",
  Cr = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  Gr = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  Br = "(?:" + Ir + "|" + Sr + ")" + "?",
  Ar = "[\\ufe0e\\ufe0f]?" + Br + ("(?:\\u200d(?:" + [Mr, Cr, Gr].join("|") + ")[\\ufe0e\\ufe0f]?" + Br + ")*"),
  Lr = "(?:" + [Mr + Ir + "?", Ir, Cr, Gr, kr].join("|") + ")",
  Rr = RegExp(Sr + "(?=" + Sr + ")|" + Lr + Ar, "g");
var Tr = function Tr(e) {
  for (var n = Rr.lastIndex = 0; Rr.test(e);) ++n;
  return n;
};
var Dr = function Dr(e) {
  return Or(e) ? Tr(e) : xr(e);
};
var Pr = function Pr(e) {
  if (null == e) return 0;
  if (rn(e)) return jr(e) ? Dr(e) : e.length;
  var n = Tn(e);
  return "[object Map]" == n || "[object Set]" == n ? e.size : tn(e).length;
};
var zr = function zr(e, n, t) {
    var r = Te(e),
      o = r || Pe(e) || Ye(e);
    if (n = dr(n), null == t) {
      var i = e && e.constructor;
      t = o ? r ? new i() : [] : D(e) && z(i) ? Kn(En(e)) : {};
    }
    return (o ? xe : dt)(e, function (e, r, o) {
      return n(t, e, r, o);
    }), t;
  },
  Fr = I ? I.isConcatSpreadable : void 0;
var Ur = function Ur(e) {
  return Te(e) || Re(e) || !!(Fr && e && e[Fr]);
};
var Vr = function e(n, t, r, o, i) {
  var a = -1,
    u = n.length;
  for (r || (r = Ur), i || (i = []); ++a < u;) {
    var c = n[a];
    t > 0 && r(c) ? t > 1 ? e(c, t - 1, r, o, i) : wn(i, c) : o || (i[i.length] = c);
  }
  return i;
};
var $r = function $r(e, n, t) {
    switch (t.length) {
      case 0:
        return e.call(n);
      case 1:
        return e.call(n, t[0]);
      case 2:
        return e.call(n, t[0], t[1]);
      case 3:
        return e.call(n, t[0], t[1], t[2]);
    }
    return e.apply(n, t);
  },
  Hr = Math.max;
var Wr = function Wr(e, n, t) {
    return n = Hr(void 0 === n ? e.length - 1 : n, 0), function () {
      for (var r = arguments, o = -1, i = Hr(r.length - n, 0), a = Array(i); ++o < i;) a[o] = r[n + o];
      o = -1;
      for (var u = Array(n + 1); ++o < n;) u[o] = r[o];
      return u[n] = t(a), $r(e, this, u);
    };
  },
  qr = Ne ? function (e, n) {
    return Ne(e, "toString", {
      configurable: !0,
      enumerable: !1,
      value: ct(n),
      writable: !0
    });
  } : ht,
  Yr = Date.now;
var Jr = function (e) {
  var n = 0,
    t = 0;
  return function () {
    var r = Yr(),
      o = 16 - (r - t);
    if (t = r, o > 0) {
      if (++n >= 800) return arguments[0];
    } else n = 0;
    return e.apply(void 0, arguments);
  };
}(qr);
var Xr = function Xr(e, n) {
  return Jr(Wr(e, n, ht), e + "");
};
var Kr = function Kr(e, n, t, r) {
  for (var o = e.length, i = t + (r ? 1 : -1); r ? i-- : ++i < o;) if (n(e[i], i, e)) return i;
  return -1;
};
var Qr = function Qr(e) {
  return e != e;
};
var Zr = function Zr(e, n, t) {
  for (var r = t - 1, o = e.length; ++r < o;) if (e[r] === n) return r;
  return -1;
};
var eo = function eo(e, n, t) {
  return n == n ? Zr(e, n, t) : Kr(e, Qr, t);
};
var no = function no(e, n) {
  return !!(null == e ? 0 : e.length) && eo(e, n, 0) > -1;
};
var to = function to(e, n, t) {
  for (var r = -1, o = null == e ? 0 : e.length; ++r < o;) if (t(n, e[r])) return !0;
  return !1;
};
var ro = function ro() {},
  oo = Sn && 1 / Nt(new Sn([, -0]))[1] == 1 / 0 ? function (e) {
    return new Sn(e);
  } : ro;
var io = function io(e, n, t) {
  var r = -1,
    o = no,
    i = e.length,
    a = !0,
    u = [],
    c = u;
  if (t) a = !1, o = to;else if (i >= 200) {
    var s = n ? null : oo(e);
    if (s) return Nt(s);
    a = !1, o = _t, c = new wt();
  } else c = n ? [] : u;
  e: for (; ++r < i;) {
    var d = e[r],
      f = n ? n(d) : d;
    if (d = t || 0 !== d ? d : 0, a && f == f) {
      for (var h = c.length; h--;) if (c[h] === f) continue e;
      n && c.push(f), u.push(d);
    } else o(c, f, t) || (c !== u && c.push(f), u.push(d));
  }
  return u;
};
var ao = function ao(e) {
    return Ce(e) && rn(e);
  },
  uo = Xr(function (e) {
    return io(Vr(e, 1, ao, !0));
  });
var co = function co(e, n) {
  return Yt(n, function (n) {
    return e[n];
  });
};
var so,
  fo = function fo(e) {
    return null == e ? [] : co(e, on(e));
  };
try {
  so = {
    clone: ut,
    constant: ct,
    each: pt,
    filter: fr,
    has: vr,
    isArray: Te,
    isEmpty: gr,
    isFunction: z,
    isUndefined: yr,
    keys: on,
    map: mr,
    reduce: _r,
    size: Pr,
    transform: zr,
    union: uo,
    values: fo
  };
} catch (e) {}
so || (so = window._);
var ho = so,
  lo = vo;
function vo(e) {
  this._isDirected = !ho.has(e, "directed") || e.directed, this._isMultigraph = !!ho.has(e, "multigraph") && e.multigraph, this._isCompound = !!ho.has(e, "compound") && e.compound, this._label = void 0, this._defaultNodeLabelFn = ho.constant(void 0), this._defaultEdgeLabelFn = ho.constant(void 0), this._nodes = {}, this._isCompound && (this._parent = {}, this._children = {}, this._children["\0"] = {}), this._in = {}, this._preds = {}, this._out = {}, this._sucs = {}, this._edgeObjs = {}, this._edgeLabels = {};
}
function po(e, n) {
  e[n] ? e[n]++ : e[n] = 1;
}
function go(e, n) {
  --e[n] || delete e[n];
}
function yo(e, n, t, r) {
  var o = "" + n,
    i = "" + t;
  if (!e && o > i) {
    var a = o;
    o = i, i = a;
  }
  return o + "" + i + "" + (ho.isUndefined(r) ? "\0" : r);
}
function bo(e, n, t, r) {
  var o = "" + n,
    i = "" + t;
  if (!e && o > i) {
    var a = o;
    o = i, i = a;
  }
  var u = {
    v: o,
    w: i
  };
  return r && (u.name = r), u;
}
function mo(e, n) {
  return yo(e, n.v, n.w, n.name);
}
vo.prototype._nodeCount = 0, vo.prototype._edgeCount = 0, vo.prototype.isDirected = function () {
  return this._isDirected;
}, vo.prototype.isMultigraph = function () {
  return this._isMultigraph;
}, vo.prototype.isCompound = function () {
  return this._isCompound;
}, vo.prototype.setGraph = function (e) {
  return this._label = e, this;
}, vo.prototype.graph = function () {
  return this._label;
}, vo.prototype.setDefaultNodeLabel = function (e) {
  return ho.isFunction(e) || (e = ho.constant(e)), this._defaultNodeLabelFn = e, this;
}, vo.prototype.nodeCount = function () {
  return this._nodeCount;
}, vo.prototype.nodes = function () {
  return ho.keys(this._nodes);
}, vo.prototype.sources = function () {
  var e = this;
  return ho.filter(this.nodes(), function (n) {
    return ho.isEmpty(e._in[n]);
  });
}, vo.prototype.sinks = function () {
  var e = this;
  return ho.filter(this.nodes(), function (n) {
    return ho.isEmpty(e._out[n]);
  });
}, vo.prototype.setNodes = function (e, n) {
  var t = arguments,
    r = this;
  return ho.each(e, function (e) {
    t.length > 1 ? r.setNode(e, n) : r.setNode(e);
  }), this;
}, vo.prototype.setNode = function (e, n) {
  return ho.has(this._nodes, e) ? (arguments.length > 1 && (this._nodes[e] = n), this) : (this._nodes[e] = arguments.length > 1 ? n : this._defaultNodeLabelFn(e), this._isCompound && (this._parent[e] = "\0", this._children[e] = {}, this._children["\0"][e] = !0), this._in[e] = {}, this._preds[e] = {}, this._out[e] = {}, this._sucs[e] = {}, ++this._nodeCount, this);
}, vo.prototype.node = function (e) {
  return this._nodes[e];
}, vo.prototype.hasNode = function (e) {
  return ho.has(this._nodes, e);
}, vo.prototype.removeNode = function (e) {
  var n = this;
  if (ho.has(this._nodes, e)) {
    var t = function t(e) {
      n.removeEdge(n._edgeObjs[e]);
    };
    delete this._nodes[e], this._isCompound && (this._removeFromParentsChildList(e), delete this._parent[e], ho.each(this.children(e), function (e) {
      n.setParent(e);
    }), delete this._children[e]), ho.each(ho.keys(this._in[e]), t), delete this._in[e], delete this._preds[e], ho.each(ho.keys(this._out[e]), t), delete this._out[e], delete this._sucs[e], --this._nodeCount;
  }
  return this;
}, vo.prototype.setParent = function (e, n) {
  if (!this._isCompound) throw new Error("Cannot set parent in a non-compound graph");
  if (ho.isUndefined(n)) n = "\0";else {
    for (var t = n += ""; !ho.isUndefined(t); t = this.parent(t)) if (t === e) throw new Error("Setting " + n + " as parent of " + e + " would create a cycle");
    this.setNode(n);
  }
  return this.setNode(e), this._removeFromParentsChildList(e), this._parent[e] = n, this._children[n][e] = !0, this;
}, vo.prototype._removeFromParentsChildList = function (e) {
  delete this._children[this._parent[e]][e];
}, vo.prototype.parent = function (e) {
  if (this._isCompound) {
    var n = this._parent[e];
    if ("\0" !== n) return n;
  }
}, vo.prototype.children = function (e) {
  if (ho.isUndefined(e) && (e = "\0"), this._isCompound) {
    var n = this._children[e];
    if (n) return ho.keys(n);
  } else {
    if ("\0" === e) return this.nodes();
    if (this.hasNode(e)) return [];
  }
}, vo.prototype.predecessors = function (e) {
  var n = this._preds[e];
  if (n) return ho.keys(n);
}, vo.prototype.successors = function (e) {
  var n = this._sucs[e];
  if (n) return ho.keys(n);
}, vo.prototype.neighbors = function (e) {
  var n = this.predecessors(e);
  if (n) return ho.union(n, this.successors(e));
}, vo.prototype.isLeaf = function (e) {
  return 0 === (this.isDirected() ? this.successors(e) : this.neighbors(e)).length;
}, vo.prototype.filterNodes = function (e) {
  var n = new this.constructor({
    directed: this._isDirected,
    multigraph: this._isMultigraph,
    compound: this._isCompound
  });
  n.setGraph(this.graph());
  var t = this;
  ho.each(this._nodes, function (t, r) {
    e(r) && n.setNode(r, t);
  }), ho.each(this._edgeObjs, function (e) {
    n.hasNode(e.v) && n.hasNode(e.w) && n.setEdge(e, t.edge(e));
  });
  var r = {};
  function o(e) {
    var i = t.parent(e);
    return void 0 === i || n.hasNode(i) ? (r[e] = i, i) : i in r ? r[i] : o(i);
  }
  return this._isCompound && ho.each(n.nodes(), function (e) {
    n.setParent(e, o(e));
  }), n;
}, vo.prototype.setDefaultEdgeLabel = function (e) {
  return ho.isFunction(e) || (e = ho.constant(e)), this._defaultEdgeLabelFn = e, this;
}, vo.prototype.edgeCount = function () {
  return this._edgeCount;
}, vo.prototype.edges = function () {
  return ho.values(this._edgeObjs);
}, vo.prototype.setPath = function (e, n) {
  var t = this,
    r = arguments;
  return ho.reduce(e, function (e, o) {
    return r.length > 1 ? t.setEdge(e, o, n) : t.setEdge(e, o), o;
  }), this;
}, vo.prototype.setEdge = function () {
  var e,
    n,
    t,
    r,
    o = !1,
    i = arguments[0];
  "object" == typeof i && null !== i && "v" in i ? (e = i.v, n = i.w, t = i.name, 2 === arguments.length && (r = arguments[1], o = !0)) : (e = i, n = arguments[1], t = arguments[3], arguments.length > 2 && (r = arguments[2], o = !0)), e = "" + e, n = "" + n, ho.isUndefined(t) || (t = "" + t);
  var a = yo(this._isDirected, e, n, t);
  if (ho.has(this._edgeLabels, a)) return o && (this._edgeLabels[a] = r), this;
  if (!ho.isUndefined(t) && !this._isMultigraph) throw new Error("Cannot set a named edge when isMultigraph = false");
  this.setNode(e), this.setNode(n), this._edgeLabels[a] = o ? r : this._defaultEdgeLabelFn(e, n, t);
  var u = bo(this._isDirected, e, n, t);
  return e = u.v, n = u.w, Object.freeze(u), this._edgeObjs[a] = u, po(this._preds[n], e), po(this._sucs[e], n), this._in[n][a] = u, this._out[e][a] = u, this._edgeCount++, this;
}, vo.prototype.edge = function (e, n, t) {
  var r = 1 === arguments.length ? mo(this._isDirected, arguments[0]) : yo(this._isDirected, e, n, t);
  return this._edgeLabels[r];
}, vo.prototype.hasEdge = function (e, n, t) {
  var r = 1 === arguments.length ? mo(this._isDirected, arguments[0]) : yo(this._isDirected, e, n, t);
  return ho.has(this._edgeLabels, r);
}, vo.prototype.removeEdge = function (e, n, t) {
  var r = 1 === arguments.length ? mo(this._isDirected, arguments[0]) : yo(this._isDirected, e, n, t),
    o = this._edgeObjs[r];
  return o && (e = o.v, n = o.w, delete this._edgeLabels[r], delete this._edgeObjs[r], go(this._preds[n], e), go(this._sucs[e], n), delete this._in[n][r], delete this._out[e][r], this._edgeCount--), this;
}, vo.prototype.inEdges = function (e, n) {
  var t = this._in[e];
  if (t) {
    var r = ho.values(t);
    return n ? ho.filter(r, function (e) {
      return e.v === n;
    }) : r;
  }
}, vo.prototype.outEdges = function (e, n) {
  var t = this._out[e];
  if (t) {
    var r = ho.values(t);
    return n ? ho.filter(r, function (e) {
      return e.w === n;
    }) : r;
  }
}, vo.prototype.nodeEdges = function (e, n) {
  var t = this.inEdges(e, n);
  if (t) return t.concat(this.outEdges(e, n));
};
var wo = {
    Graph: lo,
    version: "2.1.8"
  },
  Eo = {
    write: function write(e) {
      var n = {
        options: {
          directed: e.isDirected(),
          multigraph: e.isMultigraph(),
          compound: e.isCompound()
        },
        nodes: _o(e),
        edges: jo(e)
      };
      ho.isUndefined(e.graph()) || (n.value = ho.clone(e.graph()));
      return n;
    },
    read: function read(e) {
      var n = new lo(e.options).setGraph(e.value);
      return ho.each(e.nodes, function (e) {
        n.setNode(e.v, e.value), e.parent && n.setParent(e.v, e.parent);
      }), ho.each(e.edges, function (e) {
        n.setEdge({
          v: e.v,
          w: e.w,
          name: e.name
        }, e.value);
      }), n;
    }
  };
function _o(e) {
  return ho.map(e.nodes(), function (n) {
    var t = e.node(n),
      r = e.parent(n),
      o = {
        v: n
      };
    return ho.isUndefined(t) || (o.value = t), ho.isUndefined(r) || (o.parent = r), o;
  });
}
function jo(e) {
  return ho.map(e.edges(), function (n) {
    var t = e.edge(n),
      r = {
        v: n.v,
        w: n.w
      };
    return ho.isUndefined(n.name) || (r.name = n.name), ho.isUndefined(t) || (r.value = t), r;
  });
}
var xo = function xo(e) {
  var n,
    t = {},
    r = [];
  function o(r) {
    ho.has(t, r) || (t[r] = !0, n.push(r), ho.each(e.successors(r), o), ho.each(e.predecessors(r), o));
  }
  return ho.each(e.nodes(), function (e) {
    n = [], o(e), n.length && r.push(n);
  }), r;
};
var No = Oo;
function Oo() {
  this._arr = [], this._keyIndices = {};
}
Oo.prototype.size = function () {
  return this._arr.length;
}, Oo.prototype.keys = function () {
  return this._arr.map(function (e) {
    return e.key;
  });
}, Oo.prototype.has = function (e) {
  return ho.has(this._keyIndices, e);
}, Oo.prototype.priority = function (e) {
  var n = this._keyIndices[e];
  if (void 0 !== n) return this._arr[n].priority;
}, Oo.prototype.min = function () {
  if (0 === this.size()) throw new Error("Queue underflow");
  return this._arr[0].key;
}, Oo.prototype.add = function (e, n) {
  var t = this._keyIndices;
  if (e = String(e), !ho.has(t, e)) {
    var r = this._arr,
      o = r.length;
    return t[e] = o, r.push({
      key: e,
      priority: n
    }), this._decrease(o), !0;
  }
  return !1;
}, Oo.prototype.removeMin = function () {
  this._swap(0, this._arr.length - 1);
  var e = this._arr.pop();
  return delete this._keyIndices[e.key], this._heapify(0), e.key;
}, Oo.prototype.decrease = function (e, n) {
  var t = this._keyIndices[e];
  if (n > this._arr[t].priority) throw new Error("New priority is greater than current priority. Key: " + e + " Old: " + this._arr[t].priority + " New: " + n);
  this._arr[t].priority = n, this._decrease(t);
}, Oo.prototype._heapify = function (e) {
  var n = this._arr,
    t = 2 * e,
    r = t + 1,
    o = e;
  t < n.length && (o = n[t].priority < n[o].priority ? t : o, r < n.length && (o = n[r].priority < n[o].priority ? r : o), o !== e && (this._swap(e, o), this._heapify(o)));
}, Oo.prototype._decrease = function (e) {
  for (var n, t = this._arr, r = t[e].priority; 0 !== e && !(t[n = e >> 1].priority < r);) this._swap(e, n), e = n;
}, Oo.prototype._swap = function (e, n) {
  var t = this._arr,
    r = this._keyIndices,
    o = t[e],
    i = t[n];
  t[e] = i, t[n] = o, r[i.key] = e, r[o.key] = n;
};
var ko = function ko(e, n, t, r) {
    return function (e, n, t, r) {
      var o,
        i,
        a = {},
        u = new No(),
        c = function c(e) {
          var n = e.v !== o ? e.v : e.w,
            r = a[n],
            c = t(e),
            s = i.distance + c;
          if (c < 0) throw new Error("dijkstra does not allow negative edge weights. Bad edge: " + e + " Weight: " + c);
          s < r.distance && (r.distance = s, r.predecessor = o, u.decrease(n, s));
        };
      e.nodes().forEach(function (e) {
        var t = e === n ? 0 : Number.POSITIVE_INFINITY;
        a[e] = {
          distance: t
        }, u.add(e, t);
      });
      for (; u.size() > 0 && (o = u.removeMin(), (i = a[o]).distance !== Number.POSITIVE_INFINITY);) r(o).forEach(c);
      return a;
    }(e, String(n), t || Io, r || function (n) {
      return e.outEdges(n);
    });
  },
  Io = ho.constant(1);
var So = function So(e, n, t) {
  return ho.transform(e.nodes(), function (r, o) {
    r[o] = ko(e, o, n, t);
  }, {});
};
var Mo = function Mo(e) {
  var n = 0,
    t = [],
    r = {},
    o = [];
  function i(a) {
    var u = r[a] = {
      onStack: !0,
      lowlink: n,
      index: n++
    };
    if (t.push(a), e.successors(a).forEach(function (e) {
      ho.has(r, e) ? r[e].onStack && (u.lowlink = Math.min(u.lowlink, r[e].index)) : (i(e), u.lowlink = Math.min(u.lowlink, r[e].lowlink));
    }), u.lowlink === u.index) {
      var c,
        s = [];
      do {
        c = t.pop(), r[c].onStack = !1, s.push(c);
      } while (a !== c);
      o.push(s);
    }
  }
  return e.nodes().forEach(function (e) {
    ho.has(r, e) || i(e);
  }), o;
};
var Co = function Co(e) {
  return ho.filter(Mo(e), function (n) {
    return n.length > 1 || 1 === n.length && e.hasEdge(n[0], n[0]);
  });
};
var Go = function Go(e, n, t) {
    return function (e, n, t) {
      var r = {},
        o = e.nodes();
      return o.forEach(function (e) {
        r[e] = {}, r[e][e] = {
          distance: 0
        }, o.forEach(function (n) {
          e !== n && (r[e][n] = {
            distance: Number.POSITIVE_INFINITY
          });
        }), t(e).forEach(function (t) {
          var o = t.v === e ? t.w : t.v,
            i = n(t);
          r[e][o] = {
            distance: i,
            predecessor: e
          };
        });
      }), o.forEach(function (e) {
        var n = r[e];
        o.forEach(function (t) {
          var i = r[t];
          o.forEach(function (t) {
            var r = i[e],
              o = n[t],
              a = i[t],
              u = r.distance + o.distance;
            u < a.distance && (a.distance = u, a.predecessor = o.predecessor);
          });
        });
      }), r;
    }(e, n || Bo, t || function (n) {
      return e.outEdges(n);
    });
  },
  Bo = ho.constant(1);
var Ao = Lo;
function Lo(e) {
  var n = {},
    t = {},
    r = [];
  if (ho.each(e.sinks(), function o(i) {
    if (ho.has(t, i)) throw new Ro();
    ho.has(n, i) || (t[i] = !0, n[i] = !0, ho.each(e.predecessors(i), o), delete t[i], r.push(i));
  }), ho.size(n) !== e.nodeCount()) throw new Ro();
  return r;
}
function Ro() {}
Lo.CycleException = Ro, Ro.prototype = new Error();
var To = function To(e, n, t) {
  ho.isArray(n) || (n = [n]);
  var r = (e.isDirected() ? e.successors : e.neighbors).bind(e),
    o = [],
    i = {};
  return ho.each(n, function (n) {
    if (!e.hasNode(n)) throw new Error("Graph does not have node: " + n);
    Do(e, n, "post" === t, i, r, o);
  }), o;
};
function Do(e, n, t, r, o, i) {
  ho.has(r, n) || (r[n] = !0, t || i.push(n), ho.each(o(n), function (n) {
    Do(e, n, t, r, o, i);
  }), t && i.push(n));
}
var Po,
  zo = {
    Graph: wo.Graph,
    json: Eo,
    alg: {
      components: xo,
      dijkstra: ko,
      dijkstraAll: So,
      findCycles: Co,
      floydWarshall: Go,
      isAcyclic: function isAcyclic(e) {
        try {
          Ao(e);
        } catch (e) {
          if (e instanceof Ao.CycleException) return !1;
          throw e;
        }
        return !0;
      },
      postorder: function postorder(e, n) {
        return To(e, n, "post");
      },
      preorder: function preorder(e, n) {
        return To(e, n, "pre");
      },
      prim: function prim(e, n) {
        var t,
          r = new lo(),
          o = {},
          i = new No();
        function a(e) {
          var r = e.v === t ? e.w : e.v,
            a = i.priority(r);
          if (void 0 !== a) {
            var u = n(e);
            u < a && (o[r] = t, i.decrease(r, u));
          }
        }
        if (0 === e.nodeCount()) return r;
        ho.each(e.nodes(), function (e) {
          i.add(e, Number.POSITIVE_INFINITY), r.setNode(e);
        }), i.decrease(e.nodes()[0], 0);
        var u = !1;
        for (; i.size() > 0;) {
          if (t = i.removeMin(), ho.has(o, t)) r.setEdge(t, o[t]);else {
            if (u) throw new Error("Input graph is not connected: " + e);
            u = !0;
          }
          e.nodeEdges(t).forEach(a);
        }
        return r;
      },
      tarjan: Mo,
      topsort: Ao
    },
    version: wo.version
  };
try {
  Po = zo;
} catch (e) {}
Po || (Po = window.graphlib);
var Fo = Po;
var Uo = function Uo(e) {
  return at(e, 5);
};
var Vo = function Vo(e, n, t) {
    if (!D(t)) return !1;
    var r = typeof n;
    return !!("number" == r ? rn(t) && Fe(n, t.length) : "string" == r && n in t) && h(t[n], e);
  },
  $o = Object.prototype,
  Ho = $o.hasOwnProperty,
  Wo = Xr(function (e, n) {
    e = Object(e);
    var t = -1,
      r = n.length,
      o = r > 2 ? n[2] : void 0;
    for (o && Vo(n[0], n[1], o) && (r = 1); ++t < r;) for (var i = n[t], a = dn(i), u = -1, c = a.length; ++u < c;) {
      var s = a[u],
        d = e[s];
      (void 0 === d || h(d, $o[s]) && !Ho.call(e, s)) && (e[s] = i[s]);
    }
    return e;
  });
var qo = function qo(e) {
    return function (n, t, r) {
      var o = Object(n);
      if (!rn(n)) {
        var i = dr(t);
        n = on(n), t = function t(e) {
          return i(o[e], e, o);
        };
      }
      var a = e(n, t, r);
      return a > -1 ? o[i ? n[a] : a] : void 0;
    };
  },
  Yo = /^\s+|\s+$/g,
  Jo = /^[-+]0x[0-9a-f]+$/i,
  Xo = /^0b[01]+$/i,
  Ko = /^0o[0-7]+$/i,
  Qo = parseInt;
var Zo = function Zo(e) {
  if ("number" == typeof e) return e;
  if (Pt(e)) return NaN;
  if (D(e)) {
    var n = "function" == typeof e.valueOf ? e.valueOf() : e;
    e = D(n) ? n + "" : n;
  }
  if ("string" != typeof e) return 0 === e ? e : +e;
  e = e.replace(Yo, "");
  var t = Xo.test(e);
  return t || Ko.test(e) ? Qo(e.slice(2), t ? 2 : 8) : Jo.test(e) ? NaN : +e;
};
var ei = function ei(e) {
  return e ? Infinity === (e = Zo(e)) || -Infinity === e ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
};
var ni = function ni(e) {
    var n = ei(e),
      t = n % 1;
    return n == n ? t ? n - t : n : 0;
  },
  ti = Math.max;
var ri = qo(function (e, n, t) {
  var r = null == e ? 0 : e.length;
  if (!r) return -1;
  var o = null == t ? 0 : ni(t);
  return o < 0 && (o = ti(r + o, 0)), Kr(e, dr(n), o);
});
var oi = function oi(e) {
  return (null == e ? 0 : e.length) ? Vr(e, 1) : [];
};
var ii = function ii(e, n) {
  return null == e ? e : st(e, lt(n), dn);
};
var ai = function ai(e) {
  var n = null == e ? 0 : e.length;
  return n ? e[n - 1] : void 0;
};
var ui = function ui(e, n) {
  var t = {};
  return n = dr(n), dt(e, function (e, r, o) {
    Oe(t, r, n(e, r, o));
  }), t;
};
var ci = function ci(e, n, t) {
  for (var r = -1, o = e.length; ++r < o;) {
    var i = e[r],
      a = n(i);
    if (null != a && (void 0 === u ? a == a && !Pt(a) : t(a, u))) var u = a,
      c = i;
  }
  return c;
};
var si = function si(e, n) {
  return e > n;
};
var di = function di(e) {
  return e && e.length ? ci(e, ht, si) : void 0;
};
var fi = function fi(e, n, t) {
    (void 0 !== t && !h(e[n], t) || void 0 === t && !(n in e)) && Oe(e, n, t);
  },
  hi = Function.prototype,
  li = Object.prototype,
  vi = hi.toString,
  pi = li.hasOwnProperty,
  gi = vi.call(Object);
var yi = function yi(e) {
  if (!Ce(e) || "[object Object]" != T(e)) return !1;
  var n = En(e);
  if (null === n) return !0;
  var t = pi.call(n, "constructor") && n.constructor;
  return "function" == typeof t && t instanceof t && vi.call(t) == gi;
};
var bi = function bi(e, n) {
  if (("constructor" !== n || "function" != typeof e[n]) && "__proto__" != n) return e[n];
};
var mi = function mi(e) {
  return Se(e, dn(e));
};
var wi = function wi(e, n, t, r, o, i, a) {
  var u = bi(e, t),
    c = bi(n, t),
    s = a.get(c);
  if (s) fi(e, t, s);else {
    var d = i ? i(u, c, t + "", e, n, a) : void 0,
      f = void 0 === d;
    if (f) {
      var h = Te(c),
        l = !h && Pe(c),
        v = !h && !l && Ye(c);
      d = c, h || l || v ? Te(u) ? d = u : ao(u) ? d = ln(u) : l ? (f = !1, d = hn(c, !0)) : v ? (f = !1, d = Yn(c, !0)) : d = [] : yi(c) || Re(c) ? (d = u, Re(u) ? d = mi(u) : D(u) && !z(u) || (d = Qn(c))) : f = !1;
    }
    f && (a.set(c, d), o(d, c, r, i, a), a.delete(c)), fi(e, t, d);
  }
};
var Ei = function e(n, t, r, o, i) {
  n !== t && st(t, function (a, u) {
    if (i || (i = new je()), D(a)) wi(n, t, u, r, e, o, i);else {
      var c = o ? o(bi(n, u), a, u + "", n, t, i) : void 0;
      void 0 === c && (c = a), fi(n, u, c);
    }
  }, dn);
};
var _i = function (e) {
  return Xr(function (n, t) {
    var r = -1,
      o = t.length,
      i = o > 1 ? t[o - 1] : void 0,
      a = o > 2 ? t[2] : void 0;
    for (i = e.length > 3 && "function" == typeof i ? (o--, i) : void 0, a && Vo(t[0], t[1], a) && (i = o < 3 ? void 0 : i, o = 1), n = Object(n); ++r < o;) {
      var u = t[r];
      u && e(n, u, r, i);
    }
    return n;
  });
}(function (e, n, t) {
  Ei(e, n, t);
});
var ji = function ji(e, n) {
  return e < n;
};
var xi = function xi(e) {
  return e && e.length ? ci(e, ht, ji) : void 0;
};
var Ni = function Ni(e, n) {
    return e && e.length ? ci(e, dr(n), ji) : void 0;
  },
  Oi = function Oi() {
    return k.Date.now();
  };
var ki = function ki(e, n, t, r) {
  if (!D(e)) return e;
  for (var o = -1, i = (n = Zt(n, e)).length, a = i - 1, u = e; null != u && ++o < i;) {
    var c = er(n[o]),
      s = t;
    if ("__proto__" === c || "constructor" === c || "prototype" === c) return e;
    if (o != a) {
      var d = u[c];
      void 0 === (s = r ? r(d, c, u) : void 0) && (s = D(d) ? d : Fe(n[o + 1]) ? [] : {});
    }
    Ie(u, c, s), u = u[c];
  }
  return e;
};
var Ii = function Ii(e, n, t) {
  for (var r = -1, o = n.length, i = {}; ++r < o;) {
    var a = n[r],
      u = nr(e, a);
    t(u, a) && ki(i, Zt(a, e), u);
  }
  return i;
};
var Si = function Si(e, n) {
  return Ii(e, n, function (n, t) {
    return ir(e, t);
  });
};
var Mi = function (e) {
    return Jr(Wr(e, void 0, oi), e + "");
  }(function (e, n) {
    return null == e ? {} : Si(e, n);
  }),
  Ci = Math.ceil,
  Gi = Math.max;
var Bi = function Bi(e, n, t, r) {
  for (var o = -1, i = Gi(Ci((n - e) / (t || 1)), 0), a = Array(i); i--;) a[r ? i : ++o] = e, e += t;
  return a;
};
var Ai = function (e) {
  return function (n, t, r) {
    return r && "number" != typeof r && Vo(n, t, r) && (t = r = void 0), n = ei(n), void 0 === t ? (t = n, n = 0) : t = ei(t), r = void 0 === r ? n < t ? 1 : -1 : ei(r), Bi(n, t, r, e);
  };
}();
var Li = function Li(e, n) {
  var t = e.length;
  for (e.sort(n); t--;) e[t] = e[t].value;
  return e;
};
var Ri = function Ri(e, n) {
  if (e !== n) {
    var t = void 0 !== e,
      r = null === e,
      o = e == e,
      i = Pt(e),
      a = void 0 !== n,
      u = null === n,
      c = n == n,
      s = Pt(n);
    if (!u && !s && !i && e > n || i && a && c && !u && !s || r && a && c || !t && c || !o) return 1;
    if (!r && !i && !s && e < n || s && t && o && !r && !i || u && t && o || !a && o || !c) return -1;
  }
  return 0;
};
var Ti = function Ti(e, n, t) {
  for (var r = -1, o = e.criteria, i = n.criteria, a = o.length, u = t.length; ++r < a;) {
    var c = Ri(o[r], i[r]);
    if (c) return r >= u ? c : c * ("desc" == t[r] ? -1 : 1);
  }
  return e.index - n.index;
};
var Di = function Di(e, n, t) {
    n = n.length ? Yt(n, function (e) {
      return Te(e) ? function (n) {
        return nr(n, 1 === e.length ? e[0] : e);
      } : e;
    }) : [ht];
    var r = -1;
    n = Yt(n, He(dr));
    var o = br(e, function (e, t, o) {
      return {
        criteria: Yt(n, function (n) {
          return n(e);
        }),
        index: ++r,
        value: e
      };
    });
    return Li(o, function (e, n) {
      return Ti(e, n, t);
    });
  },
  Pi = Xr(function (e, n) {
    if (null == e) return [];
    var t = n.length;
    return t > 1 && Vo(e, n[0], n[1]) ? n = [] : t > 2 && Vo(n[0], n[1], n[2]) && (n = [n[0]]), Di(e, Vr(n, 1), []);
  }),
  zi = 0;
var Fi = function Fi(e) {
  var n = ++zi;
  return Qt(e) + n;
};
var Ui = function Ui(e, n, t) {
  for (var r = -1, o = e.length, i = n.length, a = {}; ++r < o;) {
    var u = r < i ? n[r] : void 0;
    t(a, e[r], u);
  }
  return a;
};
var Vi,
  $i = function $i(e, n) {
    return Ui(e || [], n || [], Ie);
  };
try {
  Vi = {
    cloneDeep: Uo,
    constant: ct,
    defaults: Wo,
    each: pt,
    filter: fr,
    find: ri,
    flatten: oi,
    forEach: vt,
    forIn: ii,
    has: vr,
    isUndefined: yr,
    last: ai,
    map: mr,
    mapValues: ui,
    max: di,
    merge: _i,
    min: xi,
    minBy: Ni,
    now: Oi,
    pick: Mi,
    range: Ai,
    reduce: _r,
    sortBy: Pi,
    uniqueId: Fi,
    values: fo,
    zipObject: $i
  };
} catch (e) {}
Vi || (Vi = window._);
var Hi = Vi,
  Wi = qi;
function qi() {
  var e = {};
  e._next = e._prev = e, this._sentinel = e;
}
function Yi(e) {
  e._prev._next = e._next, e._next._prev = e._prev, delete e._next, delete e._prev;
}
function Ji(e, n) {
  if ("_next" !== e && "_prev" !== e) return n;
}
qi.prototype.dequeue = function () {
  var e = this._sentinel,
    n = e._prev;
  if (n !== e) return Yi(n), n;
}, qi.prototype.enqueue = function (e) {
  var n = this._sentinel;
  e._prev && e._next && Yi(e), e._next = n._next, n._next._prev = e, n._next = e, e._prev = n;
}, qi.prototype.toString = function () {
  for (var e = [], n = this._sentinel, t = n._prev; t !== n;) e.push(JSON.stringify(t, Ji)), t = t._prev;
  return "[" + e.join(", ") + "]";
};
var Xi = Fo.Graph,
  Ki = function Ki(e, n) {
    if (e.nodeCount() <= 1) return [];
    var t = function (e, n) {
        var t = new Xi(),
          r = 0,
          o = 0;
        Hi.forEach(e.nodes(), function (e) {
          t.setNode(e, {
            v: e,
            in: 0,
            out: 0
          });
        }), Hi.forEach(e.edges(), function (e) {
          var i = t.edge(e.v, e.w) || 0,
            a = n(e),
            u = i + a;
          t.setEdge(e.v, e.w, u), o = Math.max(o, t.node(e.v).out += a), r = Math.max(r, t.node(e.w).in += a);
        });
        var i = Hi.range(o + r + 3).map(function () {
            return new Wi();
          }),
          a = r + 1;
        return Hi.forEach(t.nodes(), function (e) {
          ea(i, a, t.node(e));
        }), {
          graph: t,
          buckets: i,
          zeroIdx: a
        };
      }(e, n || Qi),
      r = function (e, n, t) {
        var r,
          o = [],
          i = n[n.length - 1],
          a = n[0];
        for (; e.nodeCount();) {
          for (; r = a.dequeue();) Zi(e, n, t, r);
          for (; r = i.dequeue();) Zi(e, n, t, r);
          if (e.nodeCount()) for (var u = n.length - 2; u > 0; --u) if (r = n[u].dequeue()) {
            o = o.concat(Zi(e, n, t, r, !0));
            break;
          }
        }
        return o;
      }(t.graph, t.buckets, t.zeroIdx);
    return Hi.flatten(Hi.map(r, function (n) {
      return e.outEdges(n.v, n.w);
    }), !0);
  },
  Qi = Hi.constant(1);
function Zi(e, n, t, r, o) {
  var i = o ? [] : void 0;
  return Hi.forEach(e.inEdges(r.v), function (r) {
    var a = e.edge(r),
      u = e.node(r.v);
    o && i.push({
      v: r.v,
      w: r.w
    }), u.out -= a, ea(n, t, u);
  }), Hi.forEach(e.outEdges(r.v), function (r) {
    var o = e.edge(r),
      i = r.w,
      a = e.node(i);
    a.in -= o, ea(n, t, a);
  }), e.removeNode(r.v), i;
}
function ea(e, n, t) {
  t.out ? t.in ? e[t.out - t.in + n].enqueue(t) : e[e.length - 1].enqueue(t) : e[0].enqueue(t);
}
var na = {
  run: function run(e) {
    var n = "greedy" === e.graph().acyclicer ? Ki(e, function (e) {
      return function (n) {
        return e.edge(n).weight;
      };
    }(e)) : function (e) {
      var n = [],
        t = {},
        r = {};
      function o(i) {
        Hi.has(r, i) || (r[i] = !0, t[i] = !0, Hi.forEach(e.outEdges(i), function (e) {
          Hi.has(t, e.w) ? n.push(e) : o(e.w);
        }), delete t[i]);
      }
      return Hi.forEach(e.nodes(), o), n;
    }(e);
    Hi.forEach(n, function (n) {
      var t = e.edge(n);
      e.removeEdge(n), t.forwardName = n.name, t.reversed = !0, e.setEdge(n.w, n.v, t, Hi.uniqueId("rev"));
    });
  },
  undo: function undo(e) {
    Hi.forEach(e.edges(), function (n) {
      var t = e.edge(n);
      if (t.reversed) {
        e.removeEdge(n);
        var r = t.forwardName;
        delete t.reversed, delete t.forwardName, e.setEdge(n.w, n.v, t, r);
      }
    });
  }
};
var ta = Fo.Graph,
  ra = {
    addDummyNode: oa,
    simplify: function simplify(e) {
      var n = new ta().setGraph(e.graph());
      return Hi.forEach(e.nodes(), function (t) {
        n.setNode(t, e.node(t));
      }), Hi.forEach(e.edges(), function (t) {
        var r = n.edge(t.v, t.w) || {
            weight: 0,
            minlen: 1
          },
          o = e.edge(t);
        n.setEdge(t.v, t.w, {
          weight: r.weight + o.weight,
          minlen: Math.max(r.minlen, o.minlen)
        });
      }), n;
    },
    asNonCompoundGraph: function asNonCompoundGraph(e) {
      var n = new ta({
        multigraph: e.isMultigraph()
      }).setGraph(e.graph());
      return Hi.forEach(e.nodes(), function (t) {
        e.children(t).length || n.setNode(t, e.node(t));
      }), Hi.forEach(e.edges(), function (t) {
        n.setEdge(t, e.edge(t));
      }), n;
    },
    successorWeights: function successorWeights(e) {
      var n = Hi.map(e.nodes(), function (n) {
        var t = {};
        return Hi.forEach(e.outEdges(n), function (n) {
          t[n.w] = (t[n.w] || 0) + e.edge(n).weight;
        }), t;
      });
      return Hi.zipObject(e.nodes(), n);
    },
    predecessorWeights: function predecessorWeights(e) {
      var n = Hi.map(e.nodes(), function (n) {
        var t = {};
        return Hi.forEach(e.inEdges(n), function (n) {
          t[n.v] = (t[n.v] || 0) + e.edge(n).weight;
        }), t;
      });
      return Hi.zipObject(e.nodes(), n);
    },
    intersectRect: function intersectRect(e, n) {
      var t,
        r,
        o = e.x,
        i = e.y,
        a = n.x - o,
        u = n.y - i,
        c = e.width / 2,
        s = e.height / 2;
      if (!a && !u) throw new Error("Not possible to find intersection inside of the rectangle");
      Math.abs(u) * c > Math.abs(a) * s ? (u < 0 && (s = -s), t = s * a / u, r = s) : (a < 0 && (c = -c), t = c, r = c * u / a);
      return {
        x: o + t,
        y: i + r
      };
    },
    buildLayerMatrix: function buildLayerMatrix(e) {
      var n = Hi.map(Hi.range(ia(e) + 1), function () {
        return [];
      });
      return Hi.forEach(e.nodes(), function (t) {
        var r = e.node(t),
          o = r.rank;
        Hi.isUndefined(o) || (n[o][r.order] = t);
      }), n;
    },
    normalizeRanks: function normalizeRanks(e) {
      var n = Hi.min(Hi.map(e.nodes(), function (n) {
        return e.node(n).rank;
      }));
      Hi.forEach(e.nodes(), function (t) {
        var r = e.node(t);
        Hi.has(r, "rank") && (r.rank -= n);
      });
    },
    removeEmptyRanks: function removeEmptyRanks(e) {
      var n = Hi.min(Hi.map(e.nodes(), function (n) {
          return e.node(n).rank;
        })),
        t = [];
      Hi.forEach(e.nodes(), function (r) {
        var o = e.node(r).rank - n;
        t[o] || (t[o] = []), t[o].push(r);
      });
      var r = 0,
        o = e.graph().nodeRankFactor;
      Hi.forEach(t, function (n, t) {
        Hi.isUndefined(n) && t % o != 0 ? --r : r && Hi.forEach(n, function (n) {
          e.node(n).rank += r;
        });
      });
    },
    addBorderNode: function addBorderNode(e, n, t, r) {
      var o = {
        width: 0,
        height: 0
      };
      arguments.length >= 4 && (o.rank = t, o.order = r);
      return oa(e, "border", o, n);
    },
    maxRank: ia,
    partition: function partition(e, n) {
      var t = {
        lhs: [],
        rhs: []
      };
      return Hi.forEach(e, function (e) {
        n(e) ? t.lhs.push(e) : t.rhs.push(e);
      }), t;
    },
    time: function time(e, n) {
      var t = Hi.now();
      try {
        return n();
      } finally {
        console.log(e + " time: " + (Hi.now() - t) + "ms");
      }
    },
    notime: function notime(e, n) {
      return n();
    }
  };
function oa(e, n, t, r) {
  var o;
  do {
    o = Hi.uniqueId(r);
  } while (e.hasNode(o));
  return t.dummy = n, e.setNode(o, t), o;
}
function ia(e) {
  return Hi.max(Hi.map(e.nodes(), function (n) {
    var t = e.node(n).rank;
    if (!Hi.isUndefined(t)) return t;
  }));
}
var aa = {
  run: function run(e) {
    e.graph().dummyChains = [], Hi.forEach(e.edges(), function (n) {
      !function (e, n) {
        var t,
          r,
          o,
          i = n.v,
          a = e.node(i).rank,
          u = n.w,
          c = e.node(u).rank,
          s = n.name,
          d = e.edge(n),
          f = d.labelRank;
        if (c === a + 1) return;
        for (e.removeEdge(n), o = 0, ++a; a < c; ++o, ++a) d.points = [], r = {
          width: 0,
          height: 0,
          edgeLabel: d,
          edgeObj: n,
          rank: a
        }, t = ra.addDummyNode(e, "edge", r, "_d"), a === f && (r.width = d.width, r.height = d.height, r.dummy = "edge-label", r.labelpos = d.labelpos), e.setEdge(i, t, {
          weight: d.weight
        }, s), 0 === o && e.graph().dummyChains.push(t), i = t;
        e.setEdge(i, u, {
          weight: d.weight
        }, s);
      }(e, n);
    });
  },
  undo: function undo(e) {
    Hi.forEach(e.graph().dummyChains, function (n) {
      var t,
        r = e.node(n),
        o = r.edgeLabel;
      for (e.setEdge(r.edgeObj, o); r.dummy;) t = e.successors(n)[0], e.removeNode(n), o.points.push({
        x: r.x,
        y: r.y
      }), "edge-label" === r.dummy && (o.x = r.x, o.y = r.y, o.width = r.width, o.height = r.height), n = t, r = e.node(n);
    });
  }
};
var ua = function ua(e) {
    var n = {};
    Hi.forEach(e.sources(), function t(r) {
      var o = e.node(r);
      if (Hi.has(n, r)) return o.rank;
      n[r] = !0;
      var i = Hi.min(Hi.map(e.outEdges(r), function (n) {
        return t(n.w) - e.edge(n).minlen;
      }));
      return i !== Number.POSITIVE_INFINITY && null != i || (i = 0), o.rank = i;
    });
  },
  ca = function ca(e, n) {
    return e.node(n.w).rank - e.node(n.v).rank - e.edge(n).minlen;
  };
var sa = Fo.Graph,
  da = ca,
  fa = function fa(e) {
    var n,
      t,
      r = new sa({
        directed: !1
      }),
      o = e.nodes()[0],
      i = e.nodeCount();
    r.setNode(o, {});
    for (; ha(r, e) < i;) n = la(r, e), t = r.hasNode(n.v) ? da(e, n) : -da(e, n), va(r, e, t);
    return r;
  };
function ha(e, n) {
  return Hi.forEach(e.nodes(), function t(r) {
    Hi.forEach(n.nodeEdges(r), function (o) {
      var i = o.v,
        a = r === i ? o.w : i;
      e.hasNode(a) || da(n, o) || (e.setNode(a, {}), e.setEdge(r, a, {}), t(a));
    });
  }), e.nodeCount();
}
function la(e, n) {
  return Hi.minBy(n.edges(), function (t) {
    if (e.hasNode(t.v) !== e.hasNode(t.w)) return da(n, t);
  });
}
function va(e, n, t) {
  Hi.forEach(e.nodes(), function (e) {
    n.node(e).rank += t;
  });
}
var pa = ca,
  ga = ua,
  ya = Fo.alg.preorder,
  ba = Fo.alg.postorder,
  ma = ra.simplify,
  wa = Ea;
function Ea(e) {
  e = ma(e), ga(e);
  var n,
    t = fa(e);
  for (xa(t), _a(t, e); n = Oa(t);) Ia(t, e, n, ka(t, e, n));
}
function _a(e, n) {
  var t = ba(e, e.nodes());
  t = t.slice(0, t.length - 1), Hi.forEach(t, function (t) {
    !function (e, n, t) {
      var r = e.node(t).parent;
      e.edge(t, r).cutvalue = ja(e, n, t);
    }(e, n, t);
  });
}
function ja(e, n, t) {
  var r = e.node(t).parent,
    o = !0,
    i = n.edge(t, r),
    a = 0;
  return i || (o = !1, i = n.edge(r, t)), a = i.weight, Hi.forEach(n.nodeEdges(t), function (i) {
    var u,
      c,
      s = i.v === t,
      d = s ? i.w : i.v;
    if (d !== r) {
      var f = s === o,
        h = n.edge(i).weight;
      if (a += f ? h : -h, u = t, c = d, e.hasEdge(u, c)) {
        var l = e.edge(t, d).cutvalue;
        a += f ? -l : l;
      }
    }
  }), a;
}
function xa(e, n) {
  arguments.length < 2 && (n = e.nodes()[0]), Na(e, {}, 1, n);
}
function Na(e, n, t, r, o) {
  var i = t,
    a = e.node(r);
  return n[r] = !0, Hi.forEach(e.neighbors(r), function (o) {
    Hi.has(n, o) || (t = Na(e, n, t, o, r));
  }), a.low = i, a.lim = t++, o ? a.parent = o : delete a.parent, t;
}
function Oa(e) {
  return Hi.find(e.edges(), function (n) {
    return e.edge(n).cutvalue < 0;
  });
}
function ka(e, n, t) {
  var r = t.v,
    o = t.w;
  n.hasEdge(r, o) || (r = t.w, o = t.v);
  var i = e.node(r),
    a = e.node(o),
    u = i,
    c = !1;
  i.lim > a.lim && (u = a, c = !0);
  var s = Hi.filter(n.edges(), function (n) {
    return c === Sa(e, e.node(n.v), u) && c !== Sa(e, e.node(n.w), u);
  });
  return Hi.minBy(s, function (e) {
    return pa(n, e);
  });
}
function Ia(e, n, t, r) {
  var o = t.v,
    i = t.w;
  e.removeEdge(o, i), e.setEdge(r.v, r.w, {}), xa(e), _a(e, n), function (e, n) {
    var t = Hi.find(e.nodes(), function (e) {
        return !n.node(e).parent;
      }),
      r = ya(e, t);
    r = r.slice(1), Hi.forEach(r, function (t) {
      var r = e.node(t).parent,
        o = n.edge(t, r),
        i = !1;
      o || (o = n.edge(r, t), i = !0), n.node(t).rank = n.node(r).rank + (i ? o.minlen : -o.minlen);
    });
  }(e, n);
}
function Sa(e, n, t) {
  return t.low <= n.lim && n.lim <= t.lim;
}
Ea.initLowLimValues = xa, Ea.initCutValues = _a, Ea.calcCutValue = ja, Ea.leaveEdge = Oa, Ea.enterEdge = ka, Ea.exchangeEdges = Ia;
var Ma = ua,
  Ca = function Ca(e) {
    switch (e.graph().ranker) {
      case "network-simplex":
        Ba(e);
        break;
      case "tight-tree":
        !function (e) {
          Ma(e), fa(e);
        }(e);
        break;
      case "longest-path":
        Ga(e);
        break;
      default:
        Ba(e);
    }
  };
var Ga = Ma;
function Ba(e) {
  wa(e);
}
var Aa = function Aa(e) {
  var n = function (e) {
    var n = {},
      t = 0;
    function r(o) {
      var i = t;
      Hi.forEach(e.children(o), r), n[o] = {
        low: i,
        lim: t++
      };
    }
    return Hi.forEach(e.children(), r), n;
  }(e);
  Hi.forEach(e.graph().dummyChains, function (t) {
    for (var r = e.node(t), o = r.edgeObj, i = function (e, n, t, r) {
        var o,
          i,
          a = [],
          u = [],
          c = Math.min(n[t].low, n[r].low),
          s = Math.max(n[t].lim, n[r].lim);
        o = t;
        do {
          o = e.parent(o), a.push(o);
        } while (o && (n[o].low > c || s > n[o].lim));
        i = o, o = r;
        for (; (o = e.parent(o)) !== i;) u.push(o);
        return {
          path: a.concat(u.reverse()),
          lca: i
        };
      }(e, n, o.v, o.w), a = i.path, u = i.lca, c = 0, s = a[c], d = !0; t !== o.w;) {
      if (r = e.node(t), d) {
        for (; (s = a[c]) !== u && e.node(s).maxRank < r.rank;) c++;
        s === u && (d = !1);
      }
      if (!d) {
        for (; c < a.length - 1 && e.node(s = a[c + 1]).minRank <= r.rank;) c++;
        s = a[c];
      }
      e.setParent(t, s), t = e.successors(t)[0];
    }
  });
};
var La = {
  run: function run(e) {
    var n = ra.addDummyNode(e, "root", {}, "_root"),
      t = function (e) {
        var n = {};
        function t(r, o) {
          var i = e.children(r);
          i && i.length && Hi.forEach(i, function (e) {
            t(e, o + 1);
          }), n[r] = o;
        }
        return Hi.forEach(e.children(), function (e) {
          t(e, 1);
        }), n;
      }(e),
      r = Hi.max(Hi.values(t)) - 1,
      o = 2 * r + 1;
    e.graph().nestingRoot = n, Hi.forEach(e.edges(), function (n) {
      e.edge(n).minlen *= o;
    });
    var i = function (e) {
      return Hi.reduce(e.edges(), function (n, t) {
        return n + e.edge(t).weight;
      }, 0);
    }(e) + 1;
    Hi.forEach(e.children(), function (a) {
      Ra(e, n, o, i, r, t, a);
    }), e.graph().nodeRankFactor = o;
  },
  cleanup: function cleanup(e) {
    var n = e.graph();
    e.removeNode(n.nestingRoot), delete n.nestingRoot, Hi.forEach(e.edges(), function (n) {
      e.edge(n).nestingEdge && e.removeEdge(n);
    });
  }
};
function Ra(e, n, t, r, o, i, a) {
  var u = e.children(a);
  if (u.length) {
    var c = ra.addBorderNode(e, "_bt"),
      s = ra.addBorderNode(e, "_bb"),
      d = e.node(a);
    e.setParent(c, a), d.borderTop = c, e.setParent(s, a), d.borderBottom = s, Hi.forEach(u, function (u) {
      Ra(e, n, t, r, o, i, u);
      var d = e.node(u),
        f = d.borderTop ? d.borderTop : u,
        h = d.borderBottom ? d.borderBottom : u,
        l = d.borderTop ? r : 2 * r,
        v = f !== h ? 1 : o - i[a] + 1;
      e.setEdge(c, f, {
        weight: l,
        minlen: v,
        nestingEdge: !0
      }), e.setEdge(h, s, {
        weight: l,
        minlen: v,
        nestingEdge: !0
      });
    }), e.parent(a) || e.setEdge(n, c, {
      weight: 0,
      minlen: o + i[a]
    });
  } else a !== n && e.setEdge(n, a, {
    weight: 0,
    minlen: t
  });
}
var Ta = function Ta(e) {
  Hi.forEach(e.children(), function n(t) {
    var r = e.children(t),
      o = e.node(t);
    if (r.length && Hi.forEach(r, n), Hi.has(o, "minRank")) {
      o.borderLeft = [], o.borderRight = [];
      for (var i = o.minRank, a = o.maxRank + 1; i < a; ++i) Da(e, "borderLeft", "_bl", t, o, i), Da(e, "borderRight", "_br", t, o, i);
    }
  });
};
function Da(e, n, t, r, o, i) {
  var a = {
      width: 0,
      height: 0,
      rank: i,
      borderType: n
    },
    u = o[n][i - 1],
    c = ra.addDummyNode(e, "border", a, t);
  o[n][i] = c, e.setParent(c, r), u && e.setEdge(u, c, {
    weight: 1
  });
}
var Pa = {
  adjust: function adjust(e) {
    var n = e.graph().rankdir.toLowerCase();
    "lr" !== n && "rl" !== n || za(e);
  },
  undo: function undo(e) {
    var n = e.graph().rankdir.toLowerCase();
    "bt" !== n && "rl" !== n || function (e) {
      Hi.forEach(e.nodes(), function (n) {
        Ua(e.node(n));
      }), Hi.forEach(e.edges(), function (n) {
        var t = e.edge(n);
        Hi.forEach(t.points, Ua), Hi.has(t, "y") && Ua(t);
      });
    }(e);
    "lr" !== n && "rl" !== n || (!function (e) {
      Hi.forEach(e.nodes(), function (n) {
        Va(e.node(n));
      }), Hi.forEach(e.edges(), function (n) {
        var t = e.edge(n);
        Hi.forEach(t.points, Va), Hi.has(t, "x") && Va(t);
      });
    }(e), za(e));
  }
};
function za(e) {
  Hi.forEach(e.nodes(), function (n) {
    Fa(e.node(n));
  }), Hi.forEach(e.edges(), function (n) {
    Fa(e.edge(n));
  });
}
function Fa(e) {
  var n = e.width;
  e.width = e.height, e.height = n;
}
function Ua(e) {
  e.y = -e.y;
}
function Va(e) {
  var n = e.x;
  e.x = e.y, e.y = n;
}
var $a = function $a(e) {
  var n = {},
    t = Hi.filter(e.nodes(), function (n) {
      return !e.children(n).length;
    }),
    r = Hi.max(Hi.map(t, function (n) {
      return e.node(n).rank;
    })),
    o = Hi.map(Hi.range(r + 1), function () {
      return [];
    });
  function i(t) {
    if (!Hi.has(n, t)) {
      n[t] = !0;
      var r = e.node(t);
      o[r.rank].push(t), Hi.forEach(e.successors(t), i);
    }
  }
  var a = Hi.sortBy(t, function (n) {
    return e.node(n).rank;
  });
  return Hi.forEach(a, i), o;
};
var Ha = function Ha(e, n) {
  for (var t = 0, r = 1; r < n.length; ++r) t += Wa(e, n[r - 1], n[r]);
  return t;
};
function Wa(e, n, t) {
  for (var r = Hi.zipObject(t, Hi.map(t, function (e, n) {
      return n;
    })), o = Hi.flatten(Hi.map(n, function (n) {
      return Hi.sortBy(Hi.map(e.outEdges(n), function (n) {
        return {
          pos: r[n.w],
          weight: e.edge(n).weight
        };
      }), "pos");
    }), !0), i = 1; i < t.length;) i <<= 1;
  var a = 2 * i - 1;
  i -= 1;
  var u = Hi.map(new Array(a), function () {
      return 0;
    }),
    c = 0;
  return Hi.forEach(o.forEach(function (e) {
    var n = e.pos + i;
    u[n] += e.weight;
    for (var t = 0; n > 0;) n % 2 && (t += u[n + 1]), u[n = n - 1 >> 1] += e.weight;
    c += e.weight * t;
  })), c;
}
var qa = function qa(e, n) {
  return Hi.map(n, function (n) {
    var t = e.inEdges(n);
    if (t.length) {
      var r = Hi.reduce(t, function (n, t) {
        var r = e.edge(t),
          o = e.node(t.v);
        return {
          sum: n.sum + r.weight * o.order,
          weight: n.weight + r.weight
        };
      }, {
        sum: 0,
        weight: 0
      });
      return {
        v: n,
        barycenter: r.sum / r.weight,
        weight: r.weight
      };
    }
    return {
      v: n
    };
  });
};
var Ya = function Ya(e, n) {
  var t = {};
  return Hi.forEach(e, function (e, n) {
    var r = t[e.v] = {
      indegree: 0,
      in: [],
      out: [],
      vs: [e.v],
      i: n
    };
    Hi.isUndefined(e.barycenter) || (r.barycenter = e.barycenter, r.weight = e.weight);
  }), Hi.forEach(n.edges(), function (e) {
    var n = t[e.v],
      r = t[e.w];
    Hi.isUndefined(n) || Hi.isUndefined(r) || (r.indegree++, n.out.push(t[e.w]));
  }), function (e) {
    var n = [];
    function t(e) {
      return function (n) {
        n.merged || (Hi.isUndefined(n.barycenter) || Hi.isUndefined(e.barycenter) || n.barycenter >= e.barycenter) && function (e, n) {
          var t = 0,
            r = 0;
          e.weight && (t += e.barycenter * e.weight, r += e.weight);
          n.weight && (t += n.barycenter * n.weight, r += n.weight);
          e.vs = n.vs.concat(e.vs), e.barycenter = t / r, e.weight = r, e.i = Math.min(n.i, e.i), n.merged = !0;
        }(e, n);
      };
    }
    function r(n) {
      return function (t) {
        t.in.push(n), 0 == --t.indegree && e.push(t);
      };
    }
    for (; e.length;) {
      var o = e.pop();
      n.push(o), Hi.forEach(o.in.reverse(), t(o)), Hi.forEach(o.out, r(o));
    }
    return Hi.map(Hi.filter(n, function (e) {
      return !e.merged;
    }), function (e) {
      return Hi.pick(e, ["vs", "i", "barycenter", "weight"]);
    });
  }(Hi.filter(t, function (e) {
    return !e.indegree;
  }));
};
var Ja = function Ja(e, n) {
  var t = ra.partition(e, function (e) {
      return Hi.has(e, "barycenter");
    }),
    r = t.lhs,
    o = Hi.sortBy(t.rhs, function (e) {
      return -e.i;
    }),
    i = [],
    a = 0,
    u = 0,
    c = 0;
  r.sort((s = !!n, function (e, n) {
    return e.barycenter < n.barycenter ? -1 : e.barycenter > n.barycenter ? 1 : s ? n.i - e.i : e.i - n.i;
  })), c = Xa(i, o, c), Hi.forEach(r, function (e) {
    c += e.vs.length, i.push(e.vs), a += e.barycenter * e.weight, u += e.weight, c = Xa(i, o, c);
  });
  var s;
  var d = {
    vs: Hi.flatten(i, !0)
  };
  u && (d.barycenter = a / u, d.weight = u);
  return d;
};
function Xa(e, n, t) {
  for (var r; n.length && (r = Hi.last(n)).i <= t;) n.pop(), e.push(r.vs), t++;
  return t;
}
var Ka = function e(n, t, r, o) {
  var i = n.children(t),
    a = n.node(t),
    u = a ? a.borderLeft : void 0,
    c = a ? a.borderRight : void 0,
    s = {};
  u && (i = Hi.filter(i, function (e) {
    return e !== u && e !== c;
  }));
  var d = qa(n, i);
  Hi.forEach(d, function (t) {
    if (n.children(t.v).length) {
      var i = e(n, t.v, r, o);
      s[t.v] = i, Hi.has(i, "barycenter") && (a = t, u = i, Hi.isUndefined(a.barycenter) ? (a.barycenter = u.barycenter, a.weight = u.weight) : (a.barycenter = (a.barycenter * a.weight + u.barycenter * u.weight) / (a.weight + u.weight), a.weight += u.weight));
    }
    var a, u;
  });
  var f = Ya(d, r);
  !function (e, n) {
    Hi.forEach(e, function (e) {
      e.vs = Hi.flatten(e.vs.map(function (e) {
        return n[e] ? n[e].vs : e;
      }), !0);
    });
  }(f, s);
  var h = Ja(f, o);
  if (u && (h.vs = Hi.flatten([u, h.vs, c], !0), n.predecessors(u).length)) {
    var l = n.node(n.predecessors(u)[0]),
      v = n.node(n.predecessors(c)[0]);
    Hi.has(h, "barycenter") || (h.barycenter = 0, h.weight = 0), h.barycenter = (h.barycenter * h.weight + l.order + v.order) / (h.weight + 2), h.weight += 2;
  }
  return h;
};
var Qa = Fo.Graph,
  Za = function Za(e, n, t) {
    var r = function (e) {
        var n;
        for (; e.hasNode(n = Hi.uniqueId("_root")););
        return n;
      }(e),
      o = new Qa({
        compound: !0
      }).setGraph({
        root: r
      }).setDefaultNodeLabel(function (n) {
        return e.node(n);
      });
    return Hi.forEach(e.nodes(), function (i) {
      var a = e.node(i),
        u = e.parent(i);
      (a.rank === n || a.minRank <= n && n <= a.maxRank) && (o.setNode(i), o.setParent(i, u || r), Hi.forEach(e[t](i), function (n) {
        var t = n.v === i ? n.w : n.v,
          r = o.edge(t, i),
          a = Hi.isUndefined(r) ? 0 : r.weight;
        o.setEdge(t, i, {
          weight: e.edge(n).weight + a
        });
      }), Hi.has(a, "minRank") && o.setNode(i, {
        borderLeft: a.borderLeft[n],
        borderRight: a.borderRight[n]
      }));
    }), o;
  };
var eu = function eu(e, n, t) {
  var r,
    o = {};
  Hi.forEach(t, function (t) {
    for (var i, a, u = e.parent(t); u;) {
      if ((i = e.parent(u)) ? (a = o[i], o[i] = u) : (a = r, r = u), a && a !== u) return void n.setEdge(a, u);
      u = i;
    }
  });
};
var nu = Fo.Graph,
  tu = function tu(e) {
    var n = ra.maxRank(e),
      t = ru(e, Hi.range(1, n + 1), "inEdges"),
      r = ru(e, Hi.range(n - 1, -1, -1), "outEdges"),
      o = $a(e);
    iu(e, o);
    for (var i, a = Number.POSITIVE_INFINITY, u = 0, c = 0; c < 4; ++u, ++c) {
      ou(u % 2 ? t : r, u % 4 >= 2), o = ra.buildLayerMatrix(e);
      var s = Ha(e, o);
      s < a && (c = 0, i = Hi.cloneDeep(o), a = s);
    }
    iu(e, i);
  };
function ru(e, n, t) {
  return Hi.map(n, function (n) {
    return Za(e, n, t);
  });
}
function ou(e, n) {
  var t = new nu();
  Hi.forEach(e, function (e) {
    var r = e.graph().root,
      o = Ka(e, r, t, n);
    Hi.forEach(o.vs, function (n, t) {
      e.node(n).order = t;
    }), eu(e, t, o.vs);
  });
}
function iu(e, n) {
  Hi.forEach(n, function (n) {
    Hi.forEach(n, function (n, t) {
      e.node(n).order = t;
    });
  });
}
var au = Fo.Graph,
  uu = function uu(e) {
    var n,
      t = ra.buildLayerMatrix(e),
      r = Hi.merge(cu(e, t), su(e, t)),
      o = {};
    Hi.forEach(["u", "d"], function (i) {
      n = "u" === i ? t : Hi.values(t).reverse(), Hi.forEach(["l", "r"], function (t) {
        "r" === t && (n = Hi.map(n, function (e) {
          return Hi.values(e).reverse();
        }));
        var a = ("u" === i ? e.predecessors : e.successors).bind(e),
          u = hu(e, n, r, a),
          c = lu(e, n, u.root, u.align, "r" === t);
        "r" === t && (c = Hi.mapValues(c, function (e) {
          return -e;
        })), o[i + t] = c;
      });
    });
    var i = vu(e, o);
    return pu(o, i), gu(o, e.graph().align);
  };
function cu(e, n) {
  var t = {};
  return Hi.reduce(n, function (n, r) {
    var o = 0,
      i = 0,
      a = n.length,
      u = Hi.last(r);
    return Hi.forEach(r, function (n, c) {
      var s = function (e, n) {
          if (e.node(n).dummy) return Hi.find(e.predecessors(n), function (n) {
            return e.node(n).dummy;
          });
        }(e, n),
        d = s ? e.node(s).order : a;
      (s || n === u) && (Hi.forEach(r.slice(i, c + 1), function (n) {
        Hi.forEach(e.predecessors(n), function (r) {
          var i = e.node(r),
            a = i.order;
          !(a < o || d < a) || i.dummy && e.node(n).dummy || du(t, r, n);
        });
      }), i = c + 1, o = d);
    }), r;
  }), t;
}
function su(e, n) {
  var t = {};
  function r(n, r, o, i, a) {
    var u;
    Hi.forEach(Hi.range(r, o), function (r) {
      u = n[r], e.node(u).dummy && Hi.forEach(e.predecessors(u), function (n) {
        var r = e.node(n);
        r.dummy && (r.order < i || r.order > a) && du(t, n, u);
      });
    });
  }
  return Hi.reduce(n, function (n, t) {
    var o,
      i = -1,
      a = 0;
    return Hi.forEach(t, function (u, c) {
      if ("border" === e.node(u).dummy) {
        var s = e.predecessors(u);
        s.length && (o = e.node(s[0]).order, r(t, a, c, i, o), a = c, i = o);
      }
      r(t, a, t.length, o, n.length);
    }), t;
  }), t;
}
function du(e, n, t) {
  if (n > t) {
    var r = n;
    n = t, t = r;
  }
  var o = e[n];
  o || (e[n] = o = {}), o[t] = !0;
}
function fu(e, n, t) {
  if (n > t) {
    var r = n;
    n = t, t = r;
  }
  return Hi.has(e[n], t);
}
function hu(e, n, t, r) {
  var o = {},
    i = {},
    a = {};
  return Hi.forEach(n, function (e) {
    Hi.forEach(e, function (e, n) {
      o[e] = e, i[e] = e, a[e] = n;
    });
  }), Hi.forEach(n, function (e) {
    var n = -1;
    Hi.forEach(e, function (e) {
      var u = r(e);
      if (u.length) for (var c = ((u = Hi.sortBy(u, function (e) {
          return a[e];
        })).length - 1) / 2, s = Math.floor(c), d = Math.ceil(c); s <= d; ++s) {
        var f = u[s];
        i[e] === e && n < a[f] && !fu(t, e, f) && (i[f] = e, i[e] = o[e] = o[f], n = a[f]);
      }
    });
  }), {
    root: o,
    align: i
  };
}
function lu(e, n, t, r, o) {
  var i = {},
    a = function (e, n, t, r) {
      var o = new au(),
        i = e.graph(),
        a = function (e, n, t) {
          return function (r, o, i) {
            var a,
              u = r.node(o),
              c = r.node(i),
              s = 0;
            if (s += u.width / 2, Hi.has(u, "labelpos")) switch (u.labelpos.toLowerCase()) {
              case "l":
                a = -u.width / 2;
                break;
              case "r":
                a = u.width / 2;
            }
            if (a && (s += t ? a : -a), a = 0, s += (u.dummy ? n : e) / 2, s += (c.dummy ? n : e) / 2, s += c.width / 2, Hi.has(c, "labelpos")) switch (c.labelpos.toLowerCase()) {
              case "l":
                a = c.width / 2;
                break;
              case "r":
                a = -c.width / 2;
            }
            return a && (s += t ? a : -a), a = 0, s;
          };
        }(i.nodesep, i.edgesep, r);
      return Hi.forEach(n, function (n) {
        var r;
        Hi.forEach(n, function (n) {
          var i = t[n];
          if (o.setNode(i), r) {
            var u = t[r],
              c = o.edge(u, i);
            o.setEdge(u, i, Math.max(a(e, n, r), c || 0));
          }
          r = n;
        });
      }), o;
    }(e, n, t, o),
    u = o ? "borderLeft" : "borderRight";
  function c(e, n) {
    for (var t = a.nodes(), r = t.pop(), o = {}; r;) o[r] ? e(r) : (o[r] = !0, t.push(r), t = t.concat(n(r))), r = t.pop();
  }
  return c(function (e) {
    i[e] = a.inEdges(e).reduce(function (e, n) {
      return Math.max(e, i[n.v] + a.edge(n));
    }, 0);
  }, a.predecessors.bind(a)), c(function (n) {
    var t = a.outEdges(n).reduce(function (e, n) {
        return Math.min(e, i[n.w] - a.edge(n));
      }, Number.POSITIVE_INFINITY),
      r = e.node(n);
    t !== Number.POSITIVE_INFINITY && r.borderType !== u && (i[n] = Math.max(i[n], t));
  }, a.successors.bind(a)), Hi.forEach(r, function (e) {
    i[e] = i[t[e]];
  }), i;
}
function vu(e, n) {
  return Hi.minBy(Hi.values(n), function (n) {
    var t = Number.NEGATIVE_INFINITY,
      r = Number.POSITIVE_INFINITY;
    return Hi.forIn(n, function (n, o) {
      var i = function (e, n) {
        return e.node(n).width;
      }(e, o) / 2;
      t = Math.max(n + i, t), r = Math.min(n - i, r);
    }), t - r;
  });
}
function pu(e, n) {
  var t = Hi.values(n),
    r = Hi.min(t),
    o = Hi.max(t);
  Hi.forEach(["u", "d"], function (t) {
    Hi.forEach(["l", "r"], function (i) {
      var a,
        u = t + i,
        c = e[u];
      if (c !== n) {
        var s = Hi.values(c);
        (a = "l" === i ? r - Hi.min(s) : o - Hi.max(s)) && (e[u] = Hi.mapValues(c, function (e) {
          return e + a;
        }));
      }
    });
  });
}
function gu(e, n) {
  return Hi.mapValues(e.ul, function (t, r) {
    if (n) return e[n.toLowerCase()][r];
    var o = Hi.sortBy(Hi.map(e, r));
    return (o[1] + o[2]) / 2;
  });
}
var yu = uu,
  bu = function bu(e) {
    (function (e) {
      var n = ra.buildLayerMatrix(e),
        t = e.graph().ranksep,
        r = 0;
      Hi.forEach(n, function (n) {
        var o = Hi.max(Hi.map(n, function (n) {
          return e.node(n).height;
        }));
        Hi.forEach(n, function (n) {
          e.node(n).y = r + o / 2;
        }), r += o + t;
      });
    })(e = ra.asNonCompoundGraph(e)), Hi.forEach(yu(e), function (n, t) {
      e.node(t).x = n;
    });
  };
var mu = ra.normalizeRanks,
  wu = ra.removeEmptyRanks,
  Eu = ra,
  _u = Fo.Graph,
  ju = function ju(e, n) {
    var t = n && n.debugTiming ? Eu.time : Eu.notime;
    t("layout", function () {
      var n = t("  buildLayoutGraph", function () {
        return function (e) {
          var n = new _u({
              multigraph: !0,
              compound: !0
            }),
            t = Bu(e.graph());
          return n.setGraph(Hi.merge({}, Nu, Gu(t, xu), Hi.pick(t, Ou))), Hi.forEach(e.nodes(), function (t) {
            var r = Bu(e.node(t));
            n.setNode(t, Hi.defaults(Gu(r, ku), Iu)), n.setParent(t, e.parent(t));
          }), Hi.forEach(e.edges(), function (t) {
            var r = Bu(e.edge(t));
            n.setEdge(t, Hi.merge({}, Mu, Gu(r, Su), Hi.pick(r, Cu)));
          }), n;
        }(e);
      });
      t("  runLayout", function () {
        !function (e, n) {
          n("    makeSpaceForEdgeLabels", function () {
            !function (e) {
              var n = e.graph();
              n.ranksep /= 2, Hi.forEach(e.edges(), function (t) {
                var r = e.edge(t);
                r.minlen *= 2, "c" !== r.labelpos.toLowerCase() && ("TB" === n.rankdir || "BT" === n.rankdir ? r.width += r.labeloffset : r.height += r.labeloffset);
              });
            }(e);
          }), n("    removeSelfEdges", function () {
            !function (e) {
              Hi.forEach(e.edges(), function (n) {
                if (n.v === n.w) {
                  var t = e.node(n.v);
                  t.selfEdges || (t.selfEdges = []), t.selfEdges.push({
                    e: n,
                    label: e.edge(n)
                  }), e.removeEdge(n);
                }
              });
            }(e);
          }), n("    acyclic", function () {
            na.run(e);
          }), n("    nestingGraph.run", function () {
            La.run(e);
          }), n("    rank", function () {
            Ca(Eu.asNonCompoundGraph(e));
          }), n("    injectEdgeLabelProxies", function () {
            !function (e) {
              Hi.forEach(e.edges(), function (n) {
                var t = e.edge(n);
                if (t.width && t.height) {
                  var r = e.node(n.v),
                    o = {
                      rank: (e.node(n.w).rank - r.rank) / 2 + r.rank,
                      e: n
                    };
                  Eu.addDummyNode(e, "edge-proxy", o, "_ep");
                }
              });
            }(e);
          }), n("    removeEmptyRanks", function () {
            wu(e);
          }), n("    nestingGraph.cleanup", function () {
            La.cleanup(e);
          }), n("    normalizeRanks", function () {
            mu(e);
          }), n("    assignRankMinMax", function () {
            !function (e) {
              var n = 0;
              Hi.forEach(e.nodes(), function (t) {
                var r = e.node(t);
                r.borderTop && (r.minRank = e.node(r.borderTop).rank, r.maxRank = e.node(r.borderBottom).rank, n = Hi.max(n, r.maxRank));
              }), e.graph().maxRank = n;
            }(e);
          }), n("    removeEdgeLabelProxies", function () {
            !function (e) {
              Hi.forEach(e.nodes(), function (n) {
                var t = e.node(n);
                "edge-proxy" === t.dummy && (e.edge(t.e).labelRank = t.rank, e.removeNode(n));
              });
            }(e);
          }), n("    normalize.run", function () {
            aa.run(e);
          }), n("    parentDummyChains", function () {
            Aa(e);
          }), n("    addBorderSegments", function () {
            Ta(e);
          }), n("    order", function () {
            tu(e);
          }), n("    insertSelfEdges", function () {
            !function (e) {
              var n = Eu.buildLayerMatrix(e);
              Hi.forEach(n, function (n) {
                var t = 0;
                Hi.forEach(n, function (n, r) {
                  var o = e.node(n);
                  o.order = r + t, Hi.forEach(o.selfEdges, function (n) {
                    Eu.addDummyNode(e, "selfedge", {
                      width: n.label.width,
                      height: n.label.height,
                      rank: o.rank,
                      order: r + ++t,
                      e: n.e,
                      label: n.label
                    }, "_se");
                  }), delete o.selfEdges;
                });
              });
            }(e);
          }), n("    adjustCoordinateSystem", function () {
            Pa.adjust(e);
          }), n("    position", function () {
            bu(e);
          }), n("    positionSelfEdges", function () {
            !function (e) {
              Hi.forEach(e.nodes(), function (n) {
                var t = e.node(n);
                if ("selfedge" === t.dummy) {
                  var r = e.node(t.e.v),
                    o = r.x + r.width / 2,
                    i = r.y,
                    a = t.x - o,
                    u = r.height / 2;
                  e.setEdge(t.e, t.label), e.removeNode(n), t.label.points = [{
                    x: o + 2 * a / 3,
                    y: i - u
                  }, {
                    x: o + 5 * a / 6,
                    y: i - u
                  }, {
                    x: o + a,
                    y: i
                  }, {
                    x: o + 5 * a / 6,
                    y: i + u
                  }, {
                    x: o + 2 * a / 3,
                    y: i + u
                  }], t.label.x = t.x, t.label.y = t.y;
                }
              });
            }(e);
          }), n("    removeBorderNodes", function () {
            !function (e) {
              Hi.forEach(e.nodes(), function (n) {
                if (e.children(n).length) {
                  var t = e.node(n),
                    r = e.node(t.borderTop),
                    o = e.node(t.borderBottom),
                    i = e.node(Hi.last(t.borderLeft)),
                    a = e.node(Hi.last(t.borderRight));
                  t.width = Math.abs(a.x - i.x), t.height = Math.abs(o.y - r.y), t.x = i.x + t.width / 2, t.y = r.y + t.height / 2;
                }
              }), Hi.forEach(e.nodes(), function (n) {
                "border" === e.node(n).dummy && e.removeNode(n);
              });
            }(e);
          }), n("    normalize.undo", function () {
            aa.undo(e);
          }), n("    fixupEdgeLabelCoords", function () {
            !function (e) {
              Hi.forEach(e.edges(), function (n) {
                var t = e.edge(n);
                if (Hi.has(t, "x")) switch ("l" !== t.labelpos && "r" !== t.labelpos || (t.width -= t.labeloffset), t.labelpos) {
                  case "l":
                    t.x -= t.width / 2 + t.labeloffset;
                    break;
                  case "r":
                    t.x += t.width / 2 + t.labeloffset;
                }
              });
            }(e);
          }), n("    undoCoordinateSystem", function () {
            Pa.undo(e);
          }), n("    translateGraph", function () {
            !function (e) {
              var n = Number.POSITIVE_INFINITY,
                t = 0,
                r = Number.POSITIVE_INFINITY,
                o = 0,
                i = e.graph(),
                a = i.marginx || 0,
                u = i.marginy || 0;
              function c(e) {
                var i = e.x,
                  a = e.y,
                  u = e.width,
                  c = e.height;
                n = Math.min(n, i - u / 2), t = Math.max(t, i + u / 2), r = Math.min(r, a - c / 2), o = Math.max(o, a + c / 2);
              }
              Hi.forEach(e.nodes(), function (n) {
                c(e.node(n));
              }), Hi.forEach(e.edges(), function (n) {
                var t = e.edge(n);
                Hi.has(t, "x") && c(t);
              }), n -= a, r -= u, Hi.forEach(e.nodes(), function (t) {
                var o = e.node(t);
                o.x -= n, o.y -= r;
              }), Hi.forEach(e.edges(), function (t) {
                var o = e.edge(t);
                Hi.forEach(o.points, function (e) {
                  e.x -= n, e.y -= r;
                }), Hi.has(o, "x") && (o.x -= n), Hi.has(o, "y") && (o.y -= r);
              }), i.width = t - n + a, i.height = o - r + u;
            }(e);
          }), n("    assignNodeIntersects", function () {
            !function (e) {
              Hi.forEach(e.edges(), function (n) {
                var t,
                  r,
                  o = e.edge(n),
                  i = e.node(n.v),
                  a = e.node(n.w);
                o.points ? (t = o.points[0], r = o.points[o.points.length - 1]) : (o.points = [], t = a, r = i), o.points.unshift(Eu.intersectRect(i, t)), o.points.push(Eu.intersectRect(a, r));
              });
            }(e);
          }), n("    reversePoints", function () {
            !function (e) {
              Hi.forEach(e.edges(), function (n) {
                var t = e.edge(n);
                t.reversed && t.points.reverse();
              });
            }(e);
          }), n("    acyclic.undo", function () {
            na.undo(e);
          });
        }(n, t);
      }), t("  updateInputGraph", function () {
        !function (e, n) {
          Hi.forEach(e.nodes(), function (t) {
            var r = e.node(t),
              o = n.node(t);
            r && (r.x = o.x, r.y = o.y, n.children(t).length && (r.width = o.width, r.height = o.height));
          }), Hi.forEach(e.edges(), function (t) {
            var r = e.edge(t),
              o = n.edge(t);
            r.points = o.points, Hi.has(o, "x") && (r.x = o.x, r.y = o.y);
          }), e.graph().width = n.graph().width, e.graph().height = n.graph().height;
        }(e, n);
      });
    });
  };
var xu = ["nodesep", "edgesep", "ranksep", "marginx", "marginy"],
  Nu = {
    ranksep: 50,
    edgesep: 20,
    nodesep: 50,
    rankdir: "tb"
  },
  Ou = ["acyclicer", "ranker", "rankdir", "align"],
  ku = ["width", "height"],
  Iu = {
    width: 0,
    height: 0
  },
  Su = ["minlen", "weight", "width", "height", "labeloffset"],
  Mu = {
    minlen: 1,
    weight: 1,
    width: 0,
    height: 0,
    labeloffset: 10,
    labelpos: "r"
  },
  Cu = ["labelpos"];
function Gu(e, n) {
  return Hi.mapValues(Hi.pick(e, n), Number);
}
function Bu(e) {
  var n = {};
  return Hi.forEach(e, function (e, t) {
    n[t.toLowerCase()] = e;
  }), n;
}
var Au = Fo.Graph;
var Lu = {
    graphlib: Fo,
    layout: ju,
    debug: {
      debugOrdering: function debugOrdering(e) {
        var n = ra.buildLayerMatrix(e),
          t = new Au({
            compound: !0,
            multigraph: !0
          }).setGraph({});
        return Hi.forEach(e.nodes(), function (n) {
          t.setNode(n, {
            label: n
          }), t.setParent(n, "layer" + e.node(n).rank);
        }), Hi.forEach(e.edges(), function (e) {
          t.setEdge(e.v, e.w, {}, e.name);
        }), Hi.forEach(n, function (e, n) {
          var r = "layer" + n;
          t.setNode(r, {
            rank: "same"
          }), Hi.reduce(e, function (e, n) {
            return t.setEdge(e, n, {
              style: "invis"
            }), n;
          });
        }), t;
      }
    },
    util: {
      time: ra.time,
      notime: ra.notime
    },
    version: "0.8.5"
  },
  Ru = Lu.graphlib,
  Tu = Lu.layout;
var Du = function Du(e) {
  _classCallCheck(this, Du);
  this.cardinality = 1, this.include = a.UNSPECIFIED, this.isGroupNode = !1, this.parentNode = null, this.type = i.NODE, this.name = e.name, this.attr = e.attr || {}, this.inputs = e.inputs, this.path = e.path || [], this.width = e.width, this.height = e.height;
};
var Pu = function Pu() {
  _classCallCheck(this, Pu);
  this.nodes = {}, this.edges = [], this.nodes = {}, this.edges = [];
};
function zu(e) {
  var n = new Pu();
  return e.nodes.map(function (e) {
    return new Du(e);
  }).forEach(function (e) {
    n.nodes[e.name] = e, e.inputs.forEach(function (t) {
      !function (e, n, t) {
        t.name !== n.name && e.edges.push(Object.assign(Object.assign({}, t.attr), {
          v: t.name,
          w: n.name
        }));
      }(n, e, t);
    });
  }), n;
}
var Fu = /*#__PURE__*/function () {
  function Fu(e) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Fu);
    this.attr = null, this.bridgeGraph = null, this.cardinality = 0, this.depth = 1, this.include = a.UNSPECIFIED, this.isGroupNode = !0, this.parentNode = null, this.type = i.META, this.path = [], this.name = e, this.metaGraph = Hu(e, u.META, n);
  }
  _createClass(Fu, [{
    key: "getFirstChild",
    value: function getFirstChild() {
      return this.metaGraph.node(this.metaGraph.nodes()[0]);
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this = this;
      return this.metaGraph.nodes().map(function (e) {
        return _this.metaGraph.node(e);
      });
    }
  }, {
    key: "leaves",
    value: function leaves() {
      var e,
        n = [],
        t = [this];
      for (; t.length;) {
        var _r2 = t.shift();
        _r2.isGroupNode ? (e = _r2.metaGraph, e.nodes().forEach(function (n) {
          return t.push(e.node(n));
        })) : n.push(_r2.name);
      }
      return n;
    }
  }]);
  return Fu;
}();
var Uu = /*#__PURE__*/function () {
  function Uu(e, n) {
    _classCallCheck(this, Uu);
    this.v = e, this.w = n, this.baseEdgeList = [], this.inbound = null, this.name = null;
  }
  _createClass(Uu, [{
    key: "addBaseEdge",
    value: function addBaseEdge(e, n) {
      this.baseEdgeList.push(e);
    }
  }]);
  return Uu;
}();
function Vu(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Fu(e, n);
}
function $u(e, n) {
  return new Uu(e, n);
}
function Hu(e, n, t) {
  var r = t || {},
    o = new Ru.Graph(r);
  return o.setGraph({
    name: e,
    rankdir: r.rankdir,
    type: n,
    align: r.align
  }), o;
}
var Wu = /*#__PURE__*/function () {
  function Wu() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Wu);
    this.graphOptions = e, this.index = {}, this.graphOptions.compound = !0, this.root = Vu(r, this.graphOptions), this.index[r] = this.root;
  }
  _createClass(Wu, [{
    key: "getNodeMap",
    value: function getNodeMap() {
      return this.index;
    }
  }, {
    key: "node",
    value: function node(e) {
      return this.index[e];
    }
  }, {
    key: "setNode",
    value: function setNode(e, n) {
      this.index[e] = n;
    }
  }, {
    key: "getBridgeGraph",
    value: function getBridgeGraph(e) {
      var _this2 = this;
      var n = this.index[e];
      if (!n) throw Error("Could not find node in hierarchy: " + e);
      if (!("metaGraph" in n)) return null;
      var t = n;
      if (t.bridgeGraph) return t.bridgeGraph;
      var r = Hu(o, u.BRIDGE, this.graphOptions);
      if (t.bridgeGraph = r, !n.parentNode || !("metaGraph" in n.parentNode)) return r;
      var i = n.parentNode;
      return [i.metaGraph, this.getBridgeGraph(i.name)].forEach(function (n) {
        n.edges().filter(function (n) {
          return n.v === e || n.w === e;
        }).forEach(function (t) {
          var o = t.w === e;
          n.edge(t).baseEdgeList.forEach(function (n) {
            var _ref = o ? [n.w, t.v] : [n.v, t.w],
              _ref2 = _slicedToArray(_ref, 2),
              i = _ref2[0],
              a = _ref2[1],
              u = _this2.getChildName(e, i),
              c = {
                v: o ? a : u,
                w: o ? u : a
              };
            var s = r.edge(c);
            s || (s = $u(c.v, c.w), s.inbound = o, r.setEdge(c.v, c.w, s)), s.addBaseEdge(n, _this2);
          });
        });
      }), r;
    }
  }, {
    key: "getChildName",
    value: function getChildName(e, n) {
      var t = this.index[n];
      for (; t;) {
        if (t.parentNode && t.parentNode.name === e) return t.name;
        t = t.parentNode;
      }
      throw Error("Could not find immediate child for descendant: " + n);
    }
  }, {
    key: "getPredecessors",
    value: function getPredecessors(e) {
      var n = this.index[e];
      if (!n) throw Error("Could not find node with name: " + e);
      return this.getOneWayEdges(n, !0);
    }
  }, {
    key: "getSuccessors",
    value: function getSuccessors(e) {
      var n = this.index[e];
      if (!n) throw Error("Could not find node with name: " + e);
      return this.getOneWayEdges(n, !1);
    }
  }, {
    key: "getOneWayEdges",
    value: function getOneWayEdges(e, n) {
      var t = [];
      if (!e.parentNode || !e.parentNode.isGroupNode) return t;
      var r = e.parentNode,
        o = r.metaGraph,
        i = this.getBridgeGraph(r.name);
      return Yu(o, e, n, t), Yu(i, e, n, t), t;
    }
  }]);
  return Wu;
}();
function qu(e, n) {
  var t = n.rankDirection,
    r = n.align,
    o = new Wu({
      rankdir: t,
      align: r
    });
  return function (e, n) {
    Object.keys(n.nodes).forEach(function (t) {
      var r = n.nodes[t],
        o = r.path;
      var i = e.root;
      i.depth = Math.max(o.length, i.depth);
      for (var _n2 = 0; _n2 < o.length && (i.depth = Math.max(i.depth, o.length - _n2), i.cardinality += r.cardinality, _n2 !== o.length - 1); _n2++) {
        var _t3 = o[_n2];
        var _a2 = e.node(_t3);
        _a2 || (_a2 = Vu(_t3, e.graphOptions), _a2.path = r.path.slice(0, _n2 + 1), _a2.parentNode = i, e.setNode(_t3, _a2), i.metaGraph.setNode(_t3, _a2)), i = _a2;
      }
      e.setNode(r.name, r), r.parentNode = i, i.metaGraph.setNode(r.name, r);
    });
  }(o, e), function (e, n) {
    var t = e.getNodeMap();
    var r = [],
      o = [];
    var i = function i(e, n) {
      var t = 0;
      for (; e;) n[t++] = e.name, e = e.parentNode;
      return t - 1;
    };
    n.edges.forEach(function (a) {
      r = [], o = [];
      var u = i(n.nodes[a.v], r),
        c = i(n.nodes[a.w], o);
      for (; r[u] === o[c];) if (u--, c--, u < 0 || c < 0) throw Error("No difference found between ancestor paths.");
      var s = t[r[u + 1]],
        d = r[u],
        f = o[c];
      var h = s.metaGraph.edge(d, f);
      h || (h = $u(d, f), s.metaGraph.setEdge(d, f, h)), h.addBaseEdge(a, e);
    });
  }(o, e), o;
}
function Yu(e, n, t, r) {
  (t ? e.inEdges(n.name) : e.outEdges(n.name)).forEach(function (n) {
    var t = e.edge(n);
    r.push(t);
  });
}
var Ju = /*#__PURE__*/function () {
  function Ju(e) {
    _classCallCheck(this, Ju);
    this.hierarchy = e, this.index = {}, this.hasSubHierarchy = {}, this.root = new Qu(this.hierarchy.root, this.hierarchy.graphOptions), this.index[e.root.name] = this.root, this.buildSubHierarchy(e.root.name), this.root.expanded = !0;
  }
  _createClass(Ju, [{
    key: "getRenderInfoNodes",
    value: function getRenderInfoNodes() {
      return Object.values(this.index);
    }
  }, {
    key: "getSubHierarchy",
    value: function getSubHierarchy() {
      return this.hasSubHierarchy;
    }
  }, {
    key: "buildSubHierarchy",
    value: function buildSubHierarchy(e) {
      var _this3 = this;
      if (e in this.hasSubHierarchy) return;
      this.hasSubHierarchy[e] = !0;
      var n = this.index[e];
      if (n.node.type !== i.META) return;
      var t = n,
        r = t.node.metaGraph,
        o = t.coreGraph;
      r.nodes().forEach(function (e) {
        var n = _this3.getOrCreateRenderNodeByName(e);
        o.setNode(e, n);
      }), r.edges().forEach(function (e) {
        var n = r.edge(e),
          t = new Ku(n);
        o.setEdge(e.v, e.w, t);
      });
      var u = t.node.parentNode;
      if (!u) return;
      var c = this.getRenderNodeByName(u.name),
        s = function s(e) {
          for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            n[_key - 1] = arguments[_key];
          }
          return n.concat([e ? "IN" : "OUT"]).join("~~");
        },
        d = this.hierarchy.getBridgeGraph(e);
      d.edges().forEach(function (n) {
        var t = d.edge(n),
          f = !!r.node(n.w),
          _ref3 = f ? [n.w, n.v] : [n.v, n.w],
          _ref4 = _slicedToArray(_ref3, 2),
          h = _ref4[0],
          l = _ref4[1],
          v = function v(n) {
            var t = f ? {
              v: n,
              w: e
            } : {
              v: e,
              w: n
            };
            return c.coreGraph.edge(t);
          };
        var p = v(l);
        p || (p = v(s(f, l, u.name)));
        var g = s(f, e),
          y = s(f, l, e);
        var b = o.node(y);
        if (!b) {
          var _e2 = o.node(g);
          if (!_e2) {
            var _n3 = {
              name: g,
              type: i.BRIDGE,
              isGroupNode: !1,
              cardinality: 0,
              parentNode: null,
              include: a.UNSPECIFIED,
              inbound: f,
              attr: {}
            };
            _e2 = new Xu(_n3), _this3.index[g] = _e2, o.setNode(g, _e2);
          }
          var _n4 = {
            name: y,
            type: i.BRIDGE,
            isGroupNode: !1,
            cardinality: 1,
            parentNode: null,
            include: a.UNSPECIFIED,
            inbound: f,
            attr: {}
          };
          b = new Xu(_n4), _this3.index[y] = b, o.setNode(y, b), o.setParent(y, g), _e2.node.cardinality++;
        }
        var m = new Ku(t);
        m.adjoiningMetaEdge = p, f ? o.setEdge(y, h, m) : o.setEdge(h, y, m);
      });
    }
  }, {
    key: "getOrCreateRenderNodeByName",
    value: function getOrCreateRenderNodeByName(e) {
      if (!e) return null;
      if (e in this.index) return this.index[e];
      var n = this.getNodeByName(e);
      return n ? (this.index[e] = n.isGroupNode ? new Qu(n, this.hierarchy.graphOptions) : new Xu(n), this.index[e]) : null;
    }
  }, {
    key: "getRenderNodeByName",
    value: function getRenderNodeByName(e) {
      return this.index[e];
    }
  }, {
    key: "getNodeByName",
    value: function getNodeByName(e) {
      return this.hierarchy.node(e);
    }
  }]);
  return Ju;
}();
var Xu = function Xu(e) {
  _classCallCheck(this, Xu);
  this.node = e, this.expanded = !1, this.x = 0, this.y = 0, this.coreBox = {
    width: 0,
    height: 0
  }, this.outboxWidth = 0, this.labelOffset = 0, this.radius = 0, this.labelHeight = 0, this.paddingTop = 0, this.paddingLeft = 0, this.paddingRight = 0, this.paddingBottom = 0, this.width = e.width || 0, this.height = e.height || 0, this.displayName = e.name, this.attr = e.attr;
};
var Ku = function Ku(e) {
  _classCallCheck(this, Ku);
  this.metaEdge = e, this.adjoiningMetaEdge = null, this.weight = 1, this.points = [];
};
var Qu = /*#__PURE__*/function (_Xu) {
  _inherits(Qu, _Xu);
  function Qu(e, n) {
    var _this4;
    _classCallCheck(this, Qu);
    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(Qu).call(this, e));
    var t = e.metaGraph.graph();
    n.compound = !0, _this4.coreGraph = Hu(t.name, u.CORE, n);
    return _this4;
  }
  return Qu;
}(Xu);
function Zu(e, t) {
  e.node.isGroupNode && function (e, t) {
    var r = n(t);
    e.coreGraph.nodes().map(function (n) {
      return e.coreGraph.node(n);
    }).forEach(function (e) {
      var n, o, a, u, c, s;
      var d = e.height,
        f = e.width;
      switch (e.node.type) {
        case i.NODE:
          Object.assign(e, r.nodeSize.node), e.height = d || r.nodeSize.node.height, e.width = f || r.nodeSize.node.width;
          break;
        case i.BRIDGE:
          Object.assign(e, r.nodeSize.bridge);
          break;
        case i.META:
          if (e.expanded) {
            Zu(e, t);
          } else Object.assign(e, r.nodeSize.meta), e.height = r.nodeSize.meta.height, e.width = r.nodeSize.meta.width;
          break;
        default:
          throw Error("Unrecognized node type: " + e.node.type);
      }
      if (!e.expanded) {
        var _r3 = e.attr;
        !function (e) {
          var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          if (e.coreBox.width = e.width, e.coreBox.height = e.height, !n) {
            var _n5 = "".concat(e.displayName).length,
              _t4 = 3;
            e.width = Math.max(e.coreBox.width, _n5 * _t4);
          }
        }(e, t && (0 === e.node.type && !!(null === (o = null === (n = null == t ? void 0 : t.nodeSize) || void 0 === n ? void 0 : n.meta) || void 0 === o ? void 0 : o.width) || 1 === e.node.type && (!!(null === (u = null === (a = null == t ? void 0 : t.nodeSize) || void 0 === a ? void 0 : a.node) || void 0 === u ? void 0 : u.width) || !!_r3.width) || 2 === e.node.type && !!(null === (s = null === (c = null == t ? void 0 : t.nodeSize) || void 0 === c ? void 0 : c.bridge) || void 0 === s ? void 0 : s.width)));
      }
    });
  }(e, t), e.node.type === i.META && function (e, t) {
    var r = n(t),
      o = r.subScene.meta;
    Object.assign(e, o);
    var _r$graph$meta = r.graph.meta,
      a = _r$graph$meta.nodeSep,
      u = _r$graph$meta.rankSep,
      c = _r$graph$meta.edgeSep,
      s = _r$graph$meta.align,
      d = {
        nodesep: a,
        ranksep: u,
        edgesep: c,
        align: s
      };
    Object.assign(e.coreBox, function (e, n) {
      var t = n.ranksep,
        r = n.nodesep,
        o = n.edgesep,
        a = n.align;
      Object.assign(e.graph(), {
        ranksep: t,
        nodesep: r,
        edgesep: o,
        align: a
      });
      var u = [];
      if (e.nodes().forEach(function (n) {
        e.node(n).node.type !== i.BRIDGE && u.push(n);
      }), !u.length) return {
        width: 0,
        height: 0
      };
      Tu(e);
      var c = 1 / 0,
        s = 1 / 0,
        d = -1 / 0,
        f = -1 / 0;
      return u.forEach(function (n) {
        var t = e.node(n),
          r = .5 * t.width,
          o = t.x - r,
          i = t.x + r;
        c = o < c ? o : c, d = i > d ? i : d;
        var a = .5 * t.height,
          u = t.y - a,
          h = t.y + a;
        s = u < s ? u : s, f = h > f ? h : f;
      }), e.edges().forEach(function (n) {
        var t = e.edge(n),
          r = e.node(t.metaEdge.v),
          o = e.node(t.metaEdge.w);
        if (3 === t.points.length && function (e) {
          var n = ec(e[0], e[1]);
          for (var _t5 = 1; _t5 < e.length - 1; _t5++) {
            var _r4 = ec(e[_t5], e[_t5 + 1]);
            if (Math.abs(_r4 - n) > 1) return !1;
            n = _r4;
          }
          return !0;
        }(t.points)) {
          if (null != r) {
            var _e3 = r.expanded ? r.x : nc(r);
            t.points[0].x = _e3;
          }
          if (null != o) {
            var _e4 = o.expanded ? o.x : nc(o);
            t.points[2].x = _e4;
          }
          t.points = [t.points[0], t.points[1]];
        }
        var i = t.points[t.points.length - 2];
        null != o && (t.points[t.points.length - 1] = tc(i, o));
        var a = t.points[1];
        null != r && (t.points[0] = tc(a, r)), t.points.forEach(function (e) {
          c = e.x < c ? e.x : c, d = e.x > d ? e.x : d, s = e.y < s ? e.y : s, f = e.y > f ? e.y : f;
        });
      }), e.nodes().forEach(function (n) {
        var t = e.node(n);
        t.x -= c, t.y -= s;
      }), e.edges().forEach(function (n) {
        e.edge(n).points.forEach(function (e) {
          e.x -= c, e.y -= s;
        });
      }), {
        width: d - c,
        height: f - s
      };
    }(e.coreGraph, d));
    var f = 0;
    e.coreGraph.nodeCount() > 0 && f++;
    var h = f <= 1 ? 0 : f;
    e.coreBox.width += h + h, e.coreBox.height = o.labelHeight + e.coreBox.height, e.width = e.coreBox.width + o.paddingLeft + o.paddingRight, e.height = e.paddingTop + e.coreBox.height + e.paddingBottom;
  }(e, t);
}
function ec(e, n) {
  var t = n.x - e.x,
    r = n.y - e.y;
  return 180 * Math.atan(r / t) / Math.PI;
}
function nc(e) {
  if (e.expanded) return e.x;
  return e.x - e.width / 2 + 0 + e.coreBox.width / 2;
}
function tc(e, n) {
  var t = n.expanded ? n.x : nc(n),
    r = n.y,
    o = e.x - t,
    i = e.y - r;
  var a,
    u,
    c = n.expanded ? n.width : n.coreBox.width,
    s = n.expanded ? n.height : n.coreBox.height;
  return Math.abs(i) * c / 2 > Math.abs(o) * s / 2 ? (i < 0 && (s = -s), a = 0 === i ? 0 : s / 2 * o / i, u = s / 2) : (o < 0 && (c = -c), a = c / 2, u = 0 === o ? 0 : c / 2 * i / o), {
    x: t + a,
    y: r + u
  };
}
function rc(n, t, r) {
  var o, i, a, u;
  var c = n.nodes.filter(function (e, n, t) {
    return t.findIndex(function (n) {
      return n.id === e.id;
    }) !== n;
  }).map(function (e) {
    return e.id;
  });
  if (c.length) throw new Error("Duplicated ids found: ".concat(c.join(", ")));
  var s = function (e) {
      var n = {
          nodes: []
        },
        t = e.compound,
        r = Object.keys(t || {}),
        o = new Map(),
        _i2 = function i(e) {
          var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          if (o.has(e)) return o.get(e);
          for (var _o2 = 0; _o2 < r.length; _o2++) {
            var _a3 = r[_o2];
            if (t && -1 !== t[_a3].indexOf(e)) return n.unshift(_a3), _i2(_a3, n);
          }
          return 0 === n.length && o.set(e, n), n;
        },
        a = function a(n) {
          return e.edges.filter(function (e) {
            return e.w === n;
          }).map(function (e) {
            return {
              name: e.v
            };
          });
        };
      return e.nodes.forEach(function (e) {
        var t = e.id,
          r = [].concat(_toConsumableArray(_i2(t)), [t]);
        var o = a(t);
        n.nodes.push({
          name: t,
          path: r,
          inputs: o,
          width: e.width,
          height: e.height,
          attr: Object.assign({}, e)
        });
      }), n;
    }(n),
    d = function (e, n) {
      var t = function t(e, n) {
          var _iterator = _createForOfIteratorHelper(n.values()),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _t6 = _step.value;
              if (_t6.includes(e)) return !0;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return !1;
        },
        _r6 = function r(e) {
          var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          if (0 === Object.keys(e).length) return _toConsumableArray(new Set(n));
          var o = new Map(Object.keys(e).map(function (n) {
              return [n, e[n]];
            })),
            i = {};
          var _iterator2 = _createForOfIteratorHelper(o),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _step2$value = _slicedToArray(_step2.value, 2),
                _e5 = _step2$value[0],
                _r5 = _step2$value[1];
              t(_e5, o) ? i[_e5] = _r5 : n = n.concat(_e5, _r5);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          return _r6(i, n);
        };
      return _r6(e).filter(function (e) {
        return n.includes(e);
      });
    }(n.compound || {}, (null == t ? void 0 : t.expanded) || []),
    f = function (e, n) {
      return function (e) {
        return new Ju(e);
      }(qu(zu(e), n));
    }(s, {
      rankDirection: (null === (i = null === (o = null == r ? void 0 : r.graph) || void 0 === o ? void 0 : o.meta) || void 0 === i ? void 0 : i.rankDir) || (null == t ? void 0 : t.rankDirection) || e.graph.meta.rankDir,
      align: (null === (u = null === (a = null == r ? void 0 : r.graph) || void 0 === a ? void 0 : a.meta) || void 0 === u ? void 0 : u.align) || e.graph.meta.align
    });
  return function (e, n) {
    n.forEach(function (n) {
      var t = e.getRenderInfoNodes().find(function (e) {
        return e.displayName === n;
      });
      var r = t && t.node && t.node.name || "";
      var o = e.getRenderNodeByName(r);
      if (!o) throw new Error("No nodes found: ".concat(r));
      o.expanded = !0, e.buildSubHierarchy(r);
    });
  }(f, d), Zu(f.root, r), ac(f.root);
}
function oc(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var t = JSON.parse(JSON.stringify(e)),
    o = {
      nodes: [t],
      edges: _toConsumableArray(t.edges)
    };
  return t.nodes.forEach(function e(n) {
    (0 === n.type || 1 === n.type) && o.nodes.push(n), 0 === n.type && (o.edges = o.edges.concat(n.edges)), Array.isArray(n.nodes) && n.nodes.forEach(e);
  }), n && o.nodes.forEach(function (e) {
    var n = o.nodes.find(function (n) {
      return n.id === e.parentNodeName;
    });
    if (n) {
      var _t7 = n.x - n.width / 2 + n.paddingLeft,
        _o3 = n.y - n.height / 2 + n.labelHeight + n.paddingTop;
      n.id !== r && (e.x += _t7, e.y += _o3), 0 === e.type && e.edges.forEach(function (n) {
        n.points.forEach(function (n) {
          n.x += e.x - e.width / 2 + e.paddingLeft, n.y += e.y - e.height / 2 + e.labelHeight + e.paddingTop;
        });
      });
    }
  }), o;
}
function ic(e, n, t, o) {
  var i, a;
  var u = [];
  var c = (null === (i = t.find(function (n) {
      return n.id === e;
    })) || void 0 === i ? void 0 : i.path) || [],
    s = (null === (a = t.find(function (e) {
      return e.id === n;
    })) || void 0 === a ? void 0 : a.path) || [],
    d = [r].concat(_toConsumableArray(c)).slice(0, c.length).reverse(),
    f = [r].concat(_toConsumableArray(s)).slice(0, s.length);
  return d.forEach(function (r) {
    var i = t.find(function (e) {
      return e.id === r;
    });
    u = u.concat(i.edges.filter(function (t) {
      return t.baseEdgeList.some(function (t) {
        return t.v === ((null == o ? void 0 : o.v) || e) && t.w === ((null == o ? void 0 : o.w) || n);
      });
    }));
  }), f.filter(function (e) {
    return !d.includes(e);
  }).forEach(function (r) {
    var i = t.find(function (e) {
      return e.id === r;
    });
    u = u.concat(i.edges.filter(function (t) {
      return t.baseEdgeList.some(function (t) {
        return t.v === ((null == o ? void 0 : o.v) || e) && t.w === ((null == o ? void 0 : o.w) || n);
      });
    }));
  }), u;
}
function ac(e) {
  var n = e.coreGraph.nodes().map(function (n) {
    return e.coreGraph.node(n);
  });
  return Object.assign(Object.assign({}, uc(e)), {
    expanded: e.expanded,
    nodes: e.expanded ? (t = n, t.map(function (e) {
      return e.node.type === i.META ? ac(e) : uc(e);
    })) : [],
    edges: e.expanded ? cc(e) : []
  });
  var t;
}
function uc(e) {
  return {
    id: e.node.name,
    name: e.node.name,
    type: e.node.type,
    cardinality: e.node.cardinality,
    attr: e.attr,
    parentNodeName: e.node.parentNode ? e.node.parentNode.name : null,
    coreBox: Object.assign({}, e.coreBox),
    x: e.x,
    y: e.y,
    width: e.width,
    height: e.height,
    radius: e.radius,
    labelHeight: e.labelHeight,
    labelOffset: e.labelOffset,
    outboxWidth: e.outboxWidth,
    paddingLeft: e.paddingLeft,
    paddingTop: e.paddingTop,
    paddingRight: e.paddingRight,
    paddingBottom: e.paddingBottom,
    path: e.node.path
  };
}
function cc(e) {
  return e.coreGraph.edges().map(function (n) {
    return {
      renderInfoEdge: e.coreGraph.edge(n),
      edge: n
    };
  }).filter(function (_ref5) {
    var e = _ref5.renderInfoEdge;
    return e.metaEdge;
  }).map(function (_ref6) {
    var n = _ref6.edge,
      t = _ref6.renderInfoEdge;
    var r = function (e, n) {
      var t = n.points.map(function (e) {
        return Object.assign({}, e);
      });
      if (n.adjoiningMetaEdge) {
        var _r7 = n.adjoiningMetaEdge.points,
          _o4 = n.metaEdge.inbound,
          _i3 = _o4 ? _r7[_r7.length - 1] : _r7[0],
          _a4 = t[_o4 ? 0 : t.length - 1],
          _u2 = e.x - e.width / 2,
          _c = e.y - e.height / 2,
          _s = _i3.x - _u2,
          _d = _i3.y - _c,
          _f = -e.paddingLeft,
          _h = -(e.paddingTop + e.labelHeight);
        _a4.x = _s + _f, _a4.y = _d + _h;
      }
      return t;
    }(e, t);
    return {
      adjoiningEdge: t.adjoiningMetaEdge ? {
        w: t.adjoiningMetaEdge.metaEdge.w,
        v: t.adjoiningMetaEdge.metaEdge.v
      } : null,
      inbound: t.metaEdge.inbound,
      w: n.w,
      v: n.v,
      points: r,
      weight: t.weight,
      baseEdgeList: t.metaEdge.baseEdgeList,
      parentNodeName: e.node.name
    };
  });
}
export { o as BRIDGE_GRAPH_NAME, u as GraphType, c as HierarchyNodeType, a as InclusionType, e as LAYOUT_CONFIG, i as NodeType, r as ROOT_NAME, rc as buildGraph, oc as flatGraph, ic as getEdges, n as mergeConfig };